// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"csIXA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Export language objects for use in other modules
parcelHelpers.export(exports, "page_text_es", ()=>(0, _esJs.page_text_es));
parcelHelpers.export(exports, "page_text_ca", ()=>(0, _caJs.page_text_ca));
parcelHelpers.export(exports, "page_lng", ()=>page_lng);
parcelHelpers.export(exports, "server_url", ()=>server_url);
parcelHelpers.export(exports, "old_server_url", ()=>old_server_url);
parcelHelpers.export(exports, "server_base", ()=>server_base);
parcelHelpers.export(exports, "old_server_base", ()=>old_server_base);
parcelHelpers.export(exports, "assets_base_url", ()=>assets_base_url);
parcelHelpers.export(exports, "page_text", ()=>page_text);
parcelHelpers.export(exports, "translate_page", ()=>translate_page);
parcelHelpers.export(exports, "translateServices", ()=>translateServices);
parcelHelpers.export(exports, "set_version", ()=>set_version);
parcelHelpers.export(exports, "set_enter", ()=>set_enter);
parcelHelpers.export(exports, "server_function", ()=>server_function);
parcelHelpers.export(exports, "old_server_function", ()=>old_server_function);
var _esJs = require("../lng/es.js");
var _caJs = require("../lng/ca.js");
var _apiResolverJs = require("./apiResolver.js");
var _appJson = require("../config/app.json");
var _repoJs = require("../repository/repo.js");
var _servicesJs = require("../config/services.js");
// Keep window references for backwards compatibility
window['page_text_es'] = (0, _esJs.page_text_es);
window['page_text_ca'] = (0, _caJs.page_text_ca);
const farmaval_version = '13.02';
const page_vars = getUrlVars();
window['page_vars'] = page_vars;
if (page_vars['session']) localStorage.farmaval_session = page_vars['session'];
let page_lng = 'es';
if (localStorage.getItem('farmaval_lng') !== null) page_lng = localStorage['farmaval_lng'];
const serverConfig = (0, _apiResolverJs.getServerConfig)();
const server_url = serverConfig.server_base + 'functions.php';
const old_server_url = serverConfig.old_server_base + 'code.php';
const server_base = serverConfig.server_base;
const old_server_base = serverConfig.old_server_base;
const assets_base_url = serverConfig.assets_base_url;
// Create a map of language objects
const languageMap = {
    es: (0, _esJs.page_text_es),
    ca: (0, _caJs.page_text_ca)
};
let page_text = languageMap[page_lng] || languageMap.es;
function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&#]+([^=&#]+)=([^&#]*)/gi, function(m, key, value) {
        vars[key] = value;
    });
    return vars;
}
function translate_page(lng, update = true) {
    if (update) {
        localStorage['farmaval_lng'] = lng;
        page_lng = lng;
    }
    // Get language object directly from map
    const currentPageText = languageMap[lng] || languageMap.es;
    if (!currentPageText) {
        console.error(`Language ${lng} not found. Using Spanish as fallback.`);
        return;
    }
    page_text = currentPageText;
    document.querySelectorAll('[aria-lng]').forEach((el)=>{
        const textKey = el.getAttribute('aria-lng');
        if (currentPageText[textKey]) el.innerHTML = currentPageText[textKey];
    });
    document.querySelectorAll('[aria-holder]').forEach((el)=>{
        const textKey = el.getAttribute('aria-holder');
        if (currentPageText[textKey]) el.setAttribute('placeholder', currentPageText[textKey]);
    });
    document.querySelectorAll('[aria-href]').forEach((el)=>{
        const textKey = el.getAttribute('aria-href');
        if (currentPageText[textKey]) el.setAttribute('href', currentPageText[textKey]);
    });
    document.querySelectorAll('.lng').forEach((element)=>{
        element.style.display = 'none';
    });
    document.querySelectorAll('.lng_' + lng).forEach((element)=>{
        element.style.display = 'inherit';
    });
    // Apply direct translations to services
    translateServices(lng);
}
function translateServices(language) {
    const texts = languageMap[language] || languageMap.es;
    // Mapa derivado del registry único (src/config/services.js).
    // No editar aquí — para añadir un servicio, editar SERVICES en services.js.
    const serviceTranslations = (0, _servicesJs.buildServiceTranslationsMap)();
    Object.entries(serviceTranslations).forEach(([serviceId, [nameKey, descKey]])=>{
        const serviceElement = document.getElementById(serviceId);
        if (!serviceElement) return;
        const titleEl = serviceElement.querySelector('.service_title');
        const subtitleEl = serviceElement.querySelector('.service_subtitle');
        if (titleEl && texts[nameKey]) titleEl.textContent = texts[nameKey];
        if (subtitleEl && texts[descKey]) subtitleEl.textContent = texts[descKey];
    });
    // Translate other service-related elements with aria-lng
    const noactiveTag = document.querySelectorAll('.noactive_tag');
    noactiveTag.forEach((el)=>{
        if (texts['settings_lbl_noactive']) el.textContent = texts['settings_lbl_noactive'];
    });
    // Translate probio links
    const probioVideo = document.querySelector('[aria-lng="probio_video"]');
    const probioMore = document.querySelector('[aria-lng="probio_more"]');
    if (probioVideo && texts['probio_video']) probioVideo.textContent = texts['probio_video'];
    if (probioMore && texts['probio_more']) probioMore.textContent = texts['probio_more'];
}
function set_version() {
    document.querySelectorAll('.farmaval_version').forEach((el)=>{
        el.innerHTML = farmaval_version;
    });
}
function set_enter() {
    document.querySelectorAll('[aria-enter]').forEach((el)=>{
        el.addEventListener('keyup', (e)=>{
            if (e.keyCode === 13) {
                e.preventDefault();
                document.getElementById(el.getAttribute('aria-enter')).click();
            }
        });
    });
}
async function server_function(func, params, ret = null, session = true) {
    let json;
    try {
        // Funciones migradas a la API de laravel en server v2
        // Se configuran en src/config/app.json migrate_functions
        const migrated_function = (0, _appJson.migrated_functions)[func] ?? false;
        if (migrated_function) {
            const method = migrated_function.method.toLowerCase();
            const url = migrated_function.url;
            const { data } = await (0, _repoJs.repo)[method](url, params);
            json = data;
        } else {
            if (func) params.function = func;
            if (session && localStorage.getItem('farmavel_token')) params.session = localStorage.getItem('farmavel_token');
            const res = await fetch(server_url, {
                method: 'post',
                mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('farmavel_token')}`
                },
                body: JSON.stringify(params)
            });
            json = await res.json();
            if (!json) throw new Error('server_error');
        }
    } catch (e) {
        if (!ret) return false;
        ret(false);
        return;
    }
    if (!ret || typeof ret !== 'function') return json;
    return ret(json);
}
async function old_server_function(params, session = true) {
    let json;
    try {
        if (session && localStorage.getItem('farmavel_token')) params.session = localStorage.getItem('farmavel_token');
        const res = await fetch(old_server_url, {
            method: 'post',
            mode: 'cors',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(params)
        });
        json = await res.json();
        if (!json) throw new Error('server_error');
        return json;
    } catch (e) {
        return {
            result: 'ko',
            type: 'server_error'
        };
    }
}

},{"../lng/es.js":"kgx6G","../lng/ca.js":"7s2zc","./apiResolver.js":"gZbmW","../config/app.json":"3MEjQ","../repository/repo.js":"61pSn","../config/services.js":"f3kwi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kgx6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "page_text_es", ()=>page_text_es);
const page_text_es = {
    // Formación (M10)
    nav_formacion: "Formaci\xf3n",
    formacion_title: "Formaci\xf3n",
    formacion_person_label: "Persona:",
    formacion_change: "Cambiar",
    formacion_who: "\xbfQui\xe9n eres?",
    formacion_who_hint: "Tu progreso y tus evaluaciones se guardan a tu nombre. Elige tu nombre de la lista del equipo.",
    formacion_no_staff: "Tu farmacia a\xfan no tiene equipo registrado. P\xeddele a Farmaval que lo d\xe9 de alta.",
    formacion_empty: "No hay contenido disponible en esta carpeta todav\xeda.",
    formacion_home: "Inicio",
    formacion_folder: "Carpeta",
    formacion_block: "Bloque",
    formacion_locked: "Bloqueado",
    formacion_seen: "Visto",
    formacion_close: "Cerrar",
    formacion_open_tab: "Abrir en pesta\xf1a",
    formacion_kind_video: "V\xeddeo",
    formacion_kind_link: "Enlace",
    formacion_kind_template: "Documento",
    formacion_kind_image: "Imagen",
    formacion_quiz_btn: "Hacer cuestionario",
    formacion_quiz_send: "Enviar respuestas",
    formacion_quiz_result: "Tu nota",
    formacion_quiz_best: "Mejor nota",
    formacion_quiz_back: "Volver",
    formacion_quiz_unanswered: "Responde todas las preguntas antes de enviar.",
    taller_inhaladores_name: "Taller de Inhaladores",
    taller_inhaladores_desc: "Formaci\xf3n pr\xe1ctica en dispositivos de inhalaci\xf3n",
    taller_insulinas_name: "Taller de Insulinas",
    taller_insulinas_desc: "Formaci\xf3n pr\xe1ctica en insulinas y plumas",
    formacion_mentoring_btn: "Agendar mentor\xeda tras la formaci\xf3n",
    formacion_mentoring_confirm: "\xbfAvisar a vuestro mentor de que quer\xe9is agendar la mentor\xeda de este bloque?",
    formacion_mentoring_sent: "\xa1Hecho! Tu mentor ha sido avisado y coordinar\xe1 la sesi\xf3n con vosotros.",
    formacion_mentoring_already: "Ya hab\xeda una solicitud pendiente para este bloque: vuestro mentor ya est\xe1 avisado.",
    formacion_result_title: "Mi resultado ProBioMentor",
    formacion_result_pending: "pendiente",
    formacion_result_noquiz: "sin examen",
    formacion_result_diploma: "Descargar diploma de experto",
    formacion_result_certificate: "Descargar certificado de aprovechamiento",
    formacion_result_retake_hint: "Puedes repetir el examen del bloque suspendido para subir tu media y conseguir el diploma (repesca).",
    formacion_result_incomplete: "Completa la evaluaci\xf3n de todos los bloques para obtener tu diploma o certificado.",
    // Servicios
    sati_name: "SATI",
    sati_desc: "Servicio de acompa\xf1amiento en terapia inhalada",
    satib_name: "SATIB",
    satib_desc: "Servicio b\xe1sico de acompa\xf1amiento en terapia inhalada",
    iretia_name: "IRETIA",
    iretia_desc: "Intervenci\xf3n r\xe1pida en terapia inhalada aguda",
    cepoc_name: "CEPOC",
    cepoc_desc: "Cribado de Enfermedad Pulmonar Obstructiva Cr\xf3nica EPOC",
    probio_name: "ProbioMentor",
    probio_desc: "Recomendaci\xf3n de probi\xf3ticos basada en evidencia",
    sati_test_name: "SATI Test",
    sati_test_desc: "Servicio en desarrollo",
    rcm_name: "RCM",
    rcm_desc: "Control de riesgo cardio metab\xf3lico",
    adir_name: "ADIR",
    adir_desc: "Ajuste de dosis en insuficiencia renal",
    // Navigation
    nav_home: "Inicio",
    nav_patients: "Pacientes",
    nav_services: "Servicios",
    nav_profile: "Perfil",
    nav_calendar: "Agenda",
    nav_reports: "Consultas",
    nav_language: "Idioma",
    nav_language_ca: "Catal\xe0",
    nav_language_es: "Espa\xf1ol",
    nav_logout: "Cerrar sesi\xf3n",
    nav_owner: "Modo titular",
    nav_marketing: "Material divulgativo",
    nav_cart: "Reposici\xf3n",
    // Carrito de reposición (FA-01 a FA-04)
    cart_tab_current: "Mi carrito",
    cart_tab_orders: "Mis pedidos",
    cart_empty: "Tu carrito est\xe1 vac\xedo. Los productos de Farmaval que vendas durante los servicios se a\xf1adir\xe1n aqu\xed autom\xe1ticamente, y tambi\xe9n puedes a\xf1adir los que quieras desde el cat\xe1logo.",
    cart_add_label: "A\xf1adir producto del cat\xe1logo",
    cart_add_price: "Precio",
    cart_btn_add: "A\xf1adir",
    cart_lbl_product: "Producto",
    cart_lbl_ref: "Referencia",
    cart_lbl_units: "Unidades",
    cart_lbl_price: "Precio",
    cart_lbl_iva: "IVA",
    cart_lbl_total: "Total",
    cart_lbl_order: "Pedido",
    cart_lbl_date: "Fecha",
    cart_lbl_shipping: "Env\xedo",
    cart_summary_title: "Resumen del pedido",
    cart_subtotal: "Base imponible",
    cart_shipping: "Gastos de env\xedo",
    cart_total: "Total",
    cart_free: "Gratis",
    cart_btn_submit: "Tramitar pedido",
    cart_btn_remove: "Quitar",
    cart_confirm_remove: "\xbfQuieres quitar este producto del carrito?",
    cart_confirm_submit: "\xbfTramitar el pedido de reposici\xf3n?",
    cart_submitting: "Tramitando...",
    cart_free_shipping_hint: "Te faltan {amount} \u20AC (sin IVA) para el env\xedo gratuito.",
    cart_free_shipping_ok: "Tu pedido tiene env\xedo gratuito.",
    cart_order_placed: "Pedido {number} tramitado correctamente.",
    cart_orders_empty: "Todav\xeda no has tramitado ning\xfan pedido de reposici\xf3n.",
    cart_order_by_farmaval: "Tramitado por Farmaval",
    cart_error_generic: "No se ha podido completar la operaci\xf3n. Vuelve a intentarlo.",
    marketing_root_label: "Inicio",
    marketing_empty: "Todav\xeda no hay material divulgativo disponible.",
    // Login
    login_title: "Inicio de sesi\xf3n",
    login_user_placeholder: "Usuario o email",
    login_password_placeholder: "Contrase\xf1a",
    login_button: "Autentificar",
    login_error_user: "Usuario o contrase\xf1a no v\xe1lidos.",
    login_error_blocked: "El acceso de esta farmacia est\xe1 desactivado. Ponte en contacto con Farmaval.",
    login_error_server: "Error de conexi\xf3n.",
    // Acceso del mentor a sus farmacias
    mentor_pharmacies_title: "Elige una farmacia",
    mentor_pharmacies_greeting: "Hola, {name}. Entrar\xe1s a la app como la farmacia que elijas.",
    mentor_pharmacies_empty: "No tienes farmacias asignadas y confirmadas.",
    mentor_pharmacy_current: "Farmacia actual",
    mentor_mirror_title: "Practicar formaci\xf3n",
    mentor_mirror_info: "Farmacia espejo, sin datos de ninguna farmacia",
    mentor_pharmacies_back: "Volver",
    mentor_error_access: "No tienes acceso a esta farmacia.",
    mentor_error_pending_services: "Hay servicios pendientes de sincronizar. Sincron\xedzalos antes de cambiar de farmacia.",
    mentor_note_cart: "El pedido lo env\xeda la farmacia.",
    mentor_note_agreement: "El contrato lo firma la farmacia.",
    mentor_banner_text: "Modo mentor: est\xe1s viendo {pharm} como {name}.",
    nav_mentor_switch: "Cambiar farmacia",
    login_password_forgotten: "Si ha olvidado la contrase\xf1a, introduzca el email y pulse [Recuperar contrase\xf1a] para recibir un correo con un c\xf3digo de recuperaci\xf3n.",
    login_send_password: "Recuperar contrase\xf1a",
    login_error_recover: "Error al inciar proceso de recuperaci\xf3n.",
    login_error_email: "Correo de recuperaci\xf3n no v\xe1lido.",
    login_recover_ok: "C\xf3digo enviado al correo.",
    update_password_title: "Actualizar contrase\xf1a",
    update_password_info: "Por motivos de seguridad, tiene que crear una contrase\xf1a nueva para acceder al aplicativo.",
    update_password_placeholder: "Contrase\xf1a nueva",
    update_repassword_placeholder: "Confirmar la contrase\xf1a nueva",
    update_password_button: "Actualizar contrase\xf1a",
    update_password_cancel: "Cancelar",
    update_password_must_1: "Debe contener al menos un n\xfamero.",
    update_password_must_2: "Debe contener al menos una letra may\xfasucla.",
    update_password_must_3: "Debe contener al menos un s\xedmbolo.",
    update_password_must_4: "Debes confirmar contrase\xf1a.",
    update_error: "Problema al actualizar contrase\xf1a. Por favor, vuelva a intentarlo antes de contactar con Farmaval.",
    update_same: "La nueva contrase\xf1a debe ser diferente a la anterior.",
    update_ok_title: "Contrase\xf1a actualizada",
    update_ok: "Tu nueva contrase\xf1a ya est\xe1 activa. \xdasala la pr\xf3xima vez que entres en Farmaval.",
    register_title: "\xa1Bienvenido!",
    register_info: "Para registrar su farmacia, por favor, introduzca un email, una contrase\xf1a de acceso y el c\xf3digo de registro suministrado por su delegado.<br><br>La contrase\xf1a debe:",
    register_email: "Email",
    register_password: "Contrase\xf1a de acceso",
    register_repassword: "Confirmar contrase\xf1a",
    register_password_must_1: "Contener al menos un n\xfamero.",
    register_password_must_2: "Contener al menos una letra may\xfasucla.",
    register_password_must_3: "Contener al menos un s\xedmbolo.",
    register_password_must_4: "Debes confirmar contrase\xf1a.",
    register_pharm: "Nombre de la farmacia",
    register_code: "C\xf3digo de Prodeco",
    register_pharm_button: "Registrar farmacia",
    register_error_func: "Se ha producido un problema inesperado. Por favor, p\xf3ngase en contacto con Farmaval.",
    register_error_email: "El email ya est\xe1 registrado.",
    register_error_code: "El c\xf3digo no es v\xe1lido.",
    register_notify_title: "Registro correcto",
    register_notify_info: "Le hemos enviado un email con los datos de registro (compruebe la bandeja de spam si no lo ha recibido). Por favor, inicie sesi\xf3n para continuar con el proceso de alta.",
    register_continue_button: "Iniciar sesi\xf3n",
    alert_code_title: "Modo Titular",
    alert_code_info: "Para acceder al modo titular debe introducir la contrase\xf1a:",
    alert_code_wrong: "Contrase\xf1a de titular incorrecta.",
    alert_code_recover: "He olvidado la contrase\xf1a",
    alert_code_recover_info: "Se enviar\xe1 un email a la direcci\xf3n de correo del titular.",
    alert_code_recover_email: "Se ha enviado un email con la nueva contrase\xf1a a la direcci\xf3n: ",
    alert_code_recover_error: "Se ha producido un error al enviar el correo con la nueva contrase\xf1a.",
    // Formación
    formation_sati: "Servicio SATI",
    formation_iretia: "Servicio IRETIA",
    formation_cepoc: "Servicio CEPOC",
    formation_all: "Sesiones de valor",
    videos_label: "Videos",
    all_videos_label: "Para el responsable",
    team_videos_label: "Para el equipo",
    material_label: "Material adicional",
    video_iretia_1: "1. Taller inhaladores Presurizados.",
    video_iretia_2: "2. Taller inhaladores Camara de inhalaci\xf3n.",
    video_iretia_3: "3. Taller inhaladores polvo seco monodosis.",
    video_iretia_4: "4. Taller inhaladores polvo seco multidosis con dep\xf3sito.",
    video_iretia_5: "5. Taller de inhaladores polvo seco con bl\xedster.",
    video_iretia_6: "6. Conceptos de aerosolterapia y distribuci\xf3n de part\xedculas.",
    video_iretia_7: "7. La t\xe9cnica inhalada.",
    link_iretia_1: "https://player.vimeo.com/video/838398122",
    link_iretia_2: "https://player.vimeo.com/video/688355173",
    link_iretia_3: "https://player.vimeo.com/video/684574347",
    link_iretia_4: "https://player.vimeo.com/video/688361792",
    link_iretia_5: "https://player.vimeo.com/video/688367203",
    link_iretia_6: "https://player.vimeo.com/video/688371703",
    link_iretia_7: "https://player.vimeo.com/video/688623093",
    material_iretia_1: "1- Consenso asma pediatr\xeda 2021 REGAP.",
    material_iretia_2: "2- Dossier formativo.",
    material_iretia_3: "3- Informe dispositivos de polvo seco unidosis.",
    material_iretia_4: "4- Informe dispositivos de polvo seco multidosis.",
    material_iretia_5: "5-Informe dispositivos presurizados sin c\xe1mara.",
    material_iretia_6: "6- Informe dispositivos presurizados con c\xe1mara.",
    material_iretia_7: "7- Informe dispositivos presurizados con c\xe1mara en ni\xf1os y lactantes.",
    file_iretia_1: "https://www.farmaval.net/docs/8-%20Consenso%20asma%20pediatria%202021%20REGAP.pdf",
    file_iretia_2: "https://www.farmaval.net/docs/9-Dossier%20formativo.pdf",
    file_iretia_3: "https://www.farmaval.net/docs/iretia/es/polvo_seco_unidosis.pdf",
    file_iretia_4: "https://www.farmaval.net/docs/iretia/es/polvo_seco_multidosis.pdf",
    file_iretia_5: "https://www.farmaval.net/docs/iretia/es/presurizados_sin_c%C3%A1mara.pdf",
    file_iretia_6: "https://www.farmaval.net/docs/iretia/es/presurizados_con_c%C3%A1mara.pdf",
    file_iretia_7: "https://www.farmaval.net/docs/iretia/es/presurizados_c%C3%A1mara_lactantes.pdf",
    video_sati_1: "1. Una historia y un sue\xf1o.",
    video_sati_2: "2. \xbfPor qu\xe9 es necesario el servicio SATI?",
    video_sati_3: "3. Nuestro rol como profesionales sanitarios.",
    video_sati_4: "4. Taller inhaladores Presurizados.",
    video_sati_5: "5. Taller inhaladores Camara de inhalaci\xf3n.",
    video_sati_6: "6. Taller inhaladores polvo seco monodosis.",
    video_sati_7: "7. Taller inhaladores polvo seco multidosis con dep\xf3sito.",
    video_sati_8: "8. Taller de inhaladores polvo seco con bl\xedster.",
    video_sati_9: "9. Taller de inhaladores: Material de soporte.",
    video_sati_10: "10. Conclusiones y plan de acci\xf3n para todo el equipo.",
    video_sati_11: "11. Conceptos de aerosolterapia y distribuci\xf3n de part\xedculas.",
    video_sati_12: "12. La t\xe9cnica inhalada.",
    video_sati_13: "13. El aparato respiratorio.",
    video_sati_14: "14. Patologia respiratoria y Principales diferencias entre Asma y EPOC.",
    video_sati_15: "15. El servicio SATI definici\xf3n.",
    video_sati_16: "16. Funcionamiento de Farmaval App.",
    video_sati_17: "17. Recogida de datos generales del paciente.",
    video_sati_18: "18. SATI LOPD.",
    video_sati_19: "19. Diagnostico y farmacoterapia.",
    video_sati_20: "20. Cuestionarios de control de la patolog\xeda respiratoria.",
    video_sati_21: "21. Educaci\xf3n sanitaria sobre la patolog\xeda respiratoria.",
    video_sati_22: "22. Valoraci\xf3n de la t\xe9cnica inhalada.",
    video_sati_23: "23. Formaci\xf3n y mejora de la t\xe9cnica inhalada.",
    video_sati_24: "24. Los dispositivos de entrenamiento.",
    video_sati_25: "25. Control del flujo inspiratorio.",
    video_sati_26: "26. La prescripci\xf3n farmac\xe9utica y el talonario de prescripci\xf3n.",
    video_sati_27: "27. Prescripci\xf3n de la c\xe1mara A2A y mascarilla de inhalaci\xf3n.",
    video_sati_28: "28. Prescripci\xf3n de InmunoRespir.",
    video_sati_29: "29. Prescripci\xf3n para las mucosas orales afectadas.",
    video_sati_30: "30. Encuesta final al paciente.",
    video_sati_31: "31. Generaci\xf3n de informes y pr\xf3xima cita.",
    video_sati_32: "32. Informe de paciente.",
    video_sati_33: "33. Informe de derivaci\xf3n por flujo insuficiente.",
    video_sati_34: "34. Otros informes de derivaci\xf3n.",
    video_sati_35: "35. Ofrecimiento del servicio en el mostrador.",
    video_sati_36: "36. Programar nuevas citas en la agenda.",
    video_sati_37: "37. Registro de las prescripciones aceptadas.",
    video_sati_38: "38. Sistema de recordatorios y mensajer\xeda.",
    video_sati_39: "39. Medidas Covid.",
    video_sati_40: "40. \xbfQui\xe9n hay detr\xe1s de Farmaval?",
    video_sati_41: "41. Elecci\xf3n inhalador principal.",
    video_sati_42: "42. \xbfQue ocurre si paciente usa dos inhaladores diferentes?",
    video_sati_43: "43. Paciente EPOC e inhalador monodosis polvo seco Handihaler.",
    video_sati_44: "44. Paciente EPOC con enfisema pulmonar e inhalador de niebla fina Respimat.",
    video_sati_45: "45. Paciente Asm\xe1tico e inhalador de polvo seco Turbuhaler.",
    link_sati_1: "https://player.vimeo.com/video/684573034",
    link_sati_2: "https://player.vimeo.com/video/685392520",
    link_sati_3: "https://player.vimeo.com/video/688345206",
    link_sati_4: "https://player.vimeo.com/video/838398122",
    link_sati_5: "https://player.vimeo.com/video/688355173",
    link_sati_6: "https://player.vimeo.com/video/684574347",
    link_sati_7: "https://player.vimeo.com/video/688361792",
    link_sati_8: "https://player.vimeo.com/video/688367203",
    link_sati_9: "https://player.vimeo.com/video/688368760",
    link_sati_10: "https://player.vimeo.com/video/838405767",
    link_sati_11: "https://player.vimeo.com/video/688371703",
    link_sati_12: "https://player.vimeo.com/video/688623093",
    link_sati_13: "https://player.vimeo.com/video/688610397",
    link_sati_14: "https://player.vimeo.com/video/688626444",
    link_sati_15: "https://player.vimeo.com/video/688610899",
    link_sati_16: "https://player.vimeo.com/video/701189206",
    link_sati_17: "https://player.vimeo.com/video/684575488",
    link_sati_18: "https://player.vimeo.com/video/684576687",
    link_sati_19: "https://player.vimeo.com/video/685396491",
    link_sati_20: "https://player.vimeo.com/video/685397299",
    link_sati_21: "https://player.vimeo.com/video/685399122",
    link_sati_22: "https://player.vimeo.com/video/685399333",
    link_sati_23: "https://player.vimeo.com/video/688612675",
    link_sati_24: "https://player.vimeo.com/video/688459718",
    link_sati_25: "https://player.vimeo.com/video/688462696",
    link_sati_26: "https://player.vimeo.com/video/701189730",
    link_sati_27: "https://player.vimeo.com/video/688614103",
    link_sati_28: "https://player.vimeo.com/video/688629258",
    link_sati_29: "https://player.vimeo.com/video/688616792",
    link_sati_30: "https://player.vimeo.com/video/688617394",
    link_sati_31: "https://player.vimeo.com/video/688620317",
    link_sati_32: "https://player.vimeo.com/video/688617623",
    link_sati_33: "https://player.vimeo.com/video/688621404",
    link_sati_34: "https://player.vimeo.com/video/701190158",
    link_sati_35: "https://player.vimeo.com/video/688621835",
    link_sati_36: "https://player.vimeo.com/video/688618095",
    link_sati_37: "https://player.vimeo.com/video/688465095",
    link_sati_38: "https://player.vimeo.com/video/688466020",
    link_sati_39: "https://player.vimeo.com/video/685406481",
    link_sati_40: "https://player.vimeo.com/video/685413171",
    link_sati_41: "https://player.vimeo.com/video/838385660",
    link_sati_42: "https://player.vimeo.com/video/838386868",
    link_sati_43: "https://player.vimeo.com/video/891112561",
    link_sati_44: "https://player.vimeo.com/video/891123647",
    link_sati_45: "https://player.vimeo.com/video/891147645",
    material_sati_1: "1- Estudio EPOCONSUL.",
    material_sati_2: "2- Informe de resultados ASPIRA 2014.",
    material_sati_3: "3- Revisi\xf3n sistem\xe1tica 2016 sobre errores en terapia inhalada.",
    material_sati_4: "4- Programa SABINA sobreuso SABA.",
    material_sati_5: "5- MiniGEMA5.1.",
    material_sati_6: "6- GINA Pocket Guide 2021.",
    material_sati_7: "7- GESEPOC2021.",
    material_sati_8: "8- Consenso asma pediatr\xeda 2021 REGAP.",
    material_sati_9: "9- Dossier formativo.",
    material_sati_10: "10- Algoritmo de resistencias de In-Check Dial.",
    material_sati_11: "11- Tabla de flujos m\xednimos y \xf3ptimos por dispositivo.",
    material_sati_12: "12- Pauta InmunoRespir.",
    material_sati_13: "13- Ofrecimiento del servicio SATI.",
    material_sati_14: "14- Cuestionario para descartar Covid-19.",
    material_sati_15: "15- Proveedores de productos SATI para farmacias.",
    material_sati_16: "16- Modelo solicitud ejercicio derechos del interesado.",
    material_sati_17: "17- Consentimiento cesi\xf3n im\xe1genes y v\xeddeos pacientes SATI.",
    material_sati_18: "18- Instrucciones solicitudes del interesado en la Farmacia.",
    material_sati_19: "19- Informe del paciente.",
    material_sati_20: "20- Informe de derivaci\xf3n b\xe1sico.",
    material_sati_21: "21- Informe de derivaci\xf3n por flujo.",
    material_sati_22: "22- Infografia asma y colageno.",
    material_sati_23: "23- Tabla de flujos \xf3ptimos por dispositivo.",
    material_sati_24: "24- Elecci\xf3n inhalador principal. Castellano",
    material_sati_25: "25- Pauta InmunoRespir.",
    material_sati_26: "26- Quecetina.",
    material_sati_27: "27- Mapa mental 3 acciones inhaladores.",
    file_sati_1: "https://www.farmaval.net/docs/1-Estudio%20EPOCONSUL.pdf",
    file_sati_2: "https://www.farmaval.net/docs/2-Informe%20de%20resultados%20ASPIRA%202014.pdf",
    file_sati_3: "https://www.farmaval.net/docs/3-%20Revisi%C3%B3n%20sistematica%202016%20sobre%20errores%20en%20terapia%20inhalada.pdf",
    file_sati_4: "https://www.farmaval.net/docs/4-%20Programa%20SABINA%20sobreuso%20SABA.pdf",
    file_sati_5: "https://www.farmaval.net/docs/5-%20MiniGEMA5.1.pdf",
    file_sati_6: "https://www.farmaval.net/docs/6-%20GINA%20Pocket%20Guide%202021.pdf",
    file_sati_7: "https://www.farmaval.net/docs/7-%20GESEPOC2021.pdf",
    file_sati_8: "https://www.farmaval.net/docs/8-%20Consenso%20asma%20pediatria%202021%20REGAP.pdf",
    file_sati_9: "https://www.farmaval.net/docs/9-Dossier%20formativo.pdf",
    file_sati_10: "https://www.farmaval.net/docs/10-%20Algoritmo%20de%20resistencias%20de%20In-Check%20Dial.pdf",
    file_sati_11: "https://www.farmaval.net/docs/11-%20Tabla%20de%20flujos%20m%C3%ADnimos%20y%20%C3%B3ptimos%20por%20dispositivo.pdf",
    file_sati_12: "https://www.farmaval.net/docs/12-%20Pauta%20InmunoRespir.pdf",
    file_sati_13: "https://www.farmaval.net/docs/13-%20Ofrecimiento%20del%20servicio%20SATI.pdf",
    file_sati_14: "https://www.farmaval.net/docs/14-%20Cuestionario%20para%20descartar%20Covid-19.pdf",
    file_sati_15: "https://www.farmaval.net/docs/15-%20Proveedores%20de%20productos%20SATI%20para%20farmacias.pdf",
    file_sati_16: "https://www.farmaval.net/docs/16-%20Modelo%20solicitud%20ejercicio%20derechos%20del%20interesado.pdf",
    file_sati_17: "https://www.farmaval.net/docs/17-Consentimiento%20cesi%C3%B3n%20imagenes%20y%20videos%20pacientes%20SATI%20.pdf",
    file_sati_18: "https://www.farmaval.net/docs/18-Instrucciones%20solicitudes%20del%20intereado%20en%20la%20Farmacia.pdf",
    file_sati_19: "https://www.farmaval.net/docs/19-Informe%20del%20paciente.pdf",
    file_sati_20: "https://www.farmaval.net/docs/20-%20Informe%20de%20derivaci%C3%B3n%20b%C3%A1sico.pdf",
    file_sati_21: "https://www.farmaval.net/docs/21-%20Informe%20de%20derivaci%C3%B3n%20por%20flujo.pdf",
    file_sati_22: "https://www.farmaval.net/docs/22-%20Infografia%20asma%20y%20colageno.pdf",
    file_sati_23: "https://www.farmaval.net/docs/23-%20Tabla%20de%20flujos%20%C3%B3ptimos%20por%20dispositivo.pdf",
    file_sati_24: "https://www.farmaval.net/docs/24-%20Elecci%C3%B3n%20inhalador%20principal.pdf",
    file_sati_25: "https://www.farmaval.net/docs/25-%20Pauta%20InmunoRespir.pdf",
    file_sati_26: "https://www.farmaval.net/docs/26-%20Quecetina.pdf",
    file_sati_27: "https://www.farmaval.net/docs/27-%20Mapa%20mental%203%20acciones%20inhaladores.pdf",
    // Calendar
    calendar_dates: "Citas",
    calendar_follow: "Seguimiento",
    calendar_cepoc: "Candidatos CEPOC",
    cepoc_filter_name: "Nombre del paciente",
    cepoc_filter_date_from: "Desde",
    cepoc_filter_date_to: "Hasta",
    cepoc_filter_btn: "Filtrar",
    cepoc_clear_btn: "Limpiar",
    cepoc_col_name: "Nombre",
    cepoc_col_phone: "Tel\xe9fono",
    cepoc_col_date: "Fecha",
    cepoc_no_results: "No hay candidatos registrados.",
    cepoc_col_actions: "Acciones",
    cepoc_btn_delete: "Eliminar",
    cepoc_confirm_delete: "\xbfEst\xe1 seguro de eliminar este candidato?",
    day_1: "Lu",
    day_2: "Ma",
    day_3: "Mi",
    day_4: "Ju",
    day_5: "Vi",
    day_6: "S\xe1",
    day_7: "Do",
    calendar_months: "Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",
    date_btn_add: "A\xf1adir cita",
    date_btn_update: "Actualizar",
    date_btn_delete: "Eliminar",
    date_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
    date_confirm_delete_text: "eliminar",
    date_no_shift: "No hay",
    date_popup_title: "Programar cita",
    date_lbl_patient: "Paciente",
    date_lbl_staff: "Persona que agenda el servicio",
    date_lbl_service: "Servicio",
    date_lbl_date: "Fecha",
    date_lbl_time: "Hora",
    date_lbl_phone: "Tel\xe9fono",
    date_lbl_comment: "Comentario",
    date_btn_cancel: "Cancelar",
    // General
    result_ok: "Operaci\xf3n realizada",
    error_empty_fields: "Datos incorrectos",
    error_operation: "Error en la operaci\xf3n",
    error_params: "100",
    error_query: "101",
    btn_new: "Nuevo",
    btn_add: "A\xf1adir",
    btn_update: "Actualizar",
    btn_delete: "Eliminar",
    // Pending
    pending_info: "Hay documentaci\xf3n que debe ser revisada y firmada antes de iniciar el servico y tener acceso a toda la funcionalidad de la aplicaci\xf3n.<br><br>Por favor, rellene todos los campos de los siguientes formularios y revise y firme los documentos:",
    pending_data: "Documentos pare revisar y firmar",
    pending_agreement_service_form: "Datos para implantaci\xf3n",
    pending_agreement_sepa_form: "Datos para SEPA",
    pending_agreement_service: "Contrato de implantaci\xf3n",
    pending_agreement_service_info: "T\xe9rminos y condiciones del servicio.",
    pending_agreement_sepa: "Orden de domiciliaci\xf3n SEPA",
    pending_agreement_sepa_info: "Documento para que su banco acepte los recibos emitidos por Farmaval.",
    pending_type_admin: "Administrador",
    pending_type_owner: "Titular",
    pending_lbl_pharm_name: "Nombre de la farmacia",
    pending_lbl_address: "Direcci\xf3n",
    pending_lbl_city: "Municipio",
    pending_lbl_state: "Comunidad aut\xf3noma",
    pending_lbl_nif: "CIF o NIF de empresa",
    pending_lbl_signer_type: "En calidad de:",
    pending_lbl_signer_dni: "DNI",
    pending_lbl_signer_name: "Nombre del firmante",
    pending_lbl_debtor_name: "Nombre del deudor",
    pending_lbl_debtor_city: "Poblaci\xf3n",
    pending_lbl_debtor_state: "Provincia",
    pending_lbl_debtor_country: "Pa\xeds",
    pending_lbl_debtor_swift: "Swift BIC",
    pending_lbl_debtor_iban: "N\xfamero de cuenta-IBAN",
    btn_pending_service: "Revisar y firmar documentos",
    btn_pending_sepa: "Revisar y firmar orden",
    pending_months: "Enero,Febrero,Marzo,Abril,Mayo,Junio,Julio,Agosto,Septiembre,Octubre,Noviembre,Diciembre",
    pending_upload: "Enviar documentaci\xf3n",
    pending_again: "Volver a firmar",
    checking_data: "Documentos en revisi\xf3n",
    checking_msg: "Se est\xe1 revisando la documentaci\xf3n.<br><br>Tan pronto como est\xe9n confirmados los datos, se les avisar\xe1 para empezar con la formaci\xf3n del equipo.<br><br>Gracias.",
    // Profile
    settings_title_info: "Informaci\xf3n",
    settings_title_pharm: "Datos",
    settings_title_admin: "Titular",
    settings_title_staff: "Equipo",
    settings_title_drugs: "Productos",
    settings_title_probiotics: "Probi\xf3ticos",
    settings_title_calendar: "D\xedas de servicio",
    settings_title_syncro: "Sincronizaci\xf3n",
    // Probióticos de farmacia — Etapa 05
    profile_probiotics_cn: "C\xf3digo Nacional",
    profile_probiotics_pvp: "PVP (\u20AC)",
    profile_probiotics_name: "Nombre",
    profile_probiotics_lab: "Laboratorio",
    profile_probiotics_strains: "Cepas",
    profile_probiotics_format: "Presentaci\xf3n",
    profile_probiotics_actions: "Acciones",
    profile_probiotics_in_matrix: "En gu\xeda",
    profile_probiotics_in_matrix_yes: "\u2713 S\xed",
    profile_probiotics_not_in_matrix: "\u26A0 No",
    profile_probiotics_lookup: "Buscar",
    profile_probiotics_add: "A\xf1adir probi\xf3tico",
    profile_probiotics_warning: "Probi\xf3tico no encontrado en la gu\xeda. Se ha notificado al equipo Curasui.",
    profile_probiotics_found: "\u2713 Encontrado en la gu\xeda \u2014 datos cargados autom\xe1ticamente",
    profile_probiotics_not_found_manual: "\u26A0 No encontrado en la gu\xeda \u2014 completa los datos m\xednimos para notificar al equipo",
    profile_probiotics_saved: "Probi\xf3tico a\xf1adido correctamente.",
    profile_probiotics_saving: "Guardando\u2026",
    profile_probiotics_deleting: "Eliminando\u2026",
    btn_activate: "Activar",
    btn_deactivate: "Desactivar",
    // Personal
    staff_lbl_name: "Nombre",
    staff_lbl_title: "Categor\xeda",
    staff_lbl_code: "N\xba colegiado",
    staff_lbl_date: "Fecha",
    staff_lbl_comment: "Comentario",
    staff_lbl_active: "Estado",
    staff_lbl_sati: "L\xedder/Responsable",
    staff_title_0: "Auxiliar",
    staff_title_1: "T\xe9cnico",
    staff_title_2: "Farmace\xfatico",
    staff_title_3: "Titular",
    staff_title_4: "Otro",
    staff_active_0: "Inactivo",
    staff_active_1: "Activo",
    staff_sati_0: "Responsable",
    staff_sati_1: "L\xedder",
    staff_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
    staff_confirm_delete_text: "eliminar",
    // días de servicio
    day_lbl_name: "D\xeda",
    day_lbl_from: "Desde",
    day_lbl_to: "Hasta",
    day_lbl_comment: "Comentario",
    day_name_0: "Lunes",
    day_name_1: "Martes",
    day_name_2: "Mi\xe9rcoles",
    day_name_3: "Jueves",
    day_name_4: "Viernes",
    day_name_5: "S\xe1bado",
    day_name_6: "Domingo",
    day_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
    day_confirm_delete_text: "eliminar",
    // productos
    prod_lbl_name: "Nombre (castellano)",
    prod_lbl_info: "Informaci\xf3n (castellano)",
    prod_lbl_name_ca: "Nombre (catal\xe1n)",
    prod_lbl_info_ca: "Informaci\xf3n (catal\xe1n)",
    prod_lbl_price: "Precio",
    prod_lbl_service: "Servicio",
    prod_lbl_creator: "Creador",
    prod_lbl_state: "Estado",
    prod_state_0: "Inactivo",
    prod_state_1: "Activo",
    prod_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
    prod_confirm_delete_text: "eliminar",
    pp_confirm_delete: "\xbfEliminar este probi\xf3tico de tu lista?",
    // farmacia
    pharm_lbl_name: "Nombre",
    pharm_lbl_business: "Raz\xf3n social",
    pharm_lbl_nif: "CIF",
    pharm_lbl_address: "Direcci\xf3n",
    pharm_lbl_city: "Ciudad",
    pharm_lbl_state: "Provincia",
    pharm_lbl_postal: "C\xf3digo postal",
    pharm_lbl_email: "Email",
    pharm_lbl_phone: "Tel\xe9fono fijo",
    pharm_lbl_mobile: "Tel\xe9fono m\xf3vil",
    pharm_lbl_web: "Web",
    pharm_lbl_admin_name: "Nombre",
    pharm_lbl_admin_code: "N\xba colegiado",
    pharm_lbl_admin_email: "Email",
    pharm_lbl_admin_signature: "Firma",
    pharm_lbl_admin_password: "Contrase\xf1a",
    pharm_lbl_user: "Usuario",
    pharm_lbl_password: "Contrase\xf1a",
    pharm_password_empty: "Dejar vac\xedo para no cambiar",
    pharm_lbl_language: "Idioma",
    pharm_lbl_password: "Contrase\xf1a",
    pharm_lbl_logo: "Logo para informes (aspecto 3/1)",
    pharm_lbl_schedule: "Horario",
    pharm_lbl_schedule_0: "Ininterrumpido",
    pharm_lbl_schedule_1: "Partido",
    pharm_lbl_schedule_2: "24 horas",
    day_btn_add: "A\xf1adir horario",
    day_btn_delete: "Eliminar",
    question_remove_day: "Eliminar horario de servicio: ",
    error_loading_days: "Problema al cargar d\xedas disponibles.",
    error_removing_day: "No se ha podido eliminar el horario.",
    error_adding_day: "No se ha podido a\xf1adir el horario.",
    // PDF viewer
    pdf_close: "Cerrar informe",
    // Popup
    popup_ok: "Aceptar",
    popup_close: "Cerrar",
    popup_cancel: "Cancelar",
    // Index
    new_link_more: "M\xe1s informaci\xf3n",
    // Index config products
    products_lbl_list: "Productos disponibles",
    products_lbl_service: "Servicio",
    error_loading_products: "Problema al cargar los productos.",
    product_lbl_name: "Producto",
    product_lbl_info: "Informaci\xf3n",
    product_lbl_cost: "Precio",
    product_lbl_cn: "CN",
    product_btn_add: "A\xf1adir",
    product_btn_edit: "Modificar",
    product_btn_delete: "Borrar",
    product_msg_empty: "Deben rellenarse todos los cmapos.",
    product_msg_cost: "El precio no es un valor correcto.",
    product_msg_error: "Se ha producido un problema al realizar la operaci\xf3n.",
    product_question_edit: "\xbfModificar el producto seleccioando?",
    product_question_delete: "\xbfEliminar el producto seleccionado?",
    // Index config days
    // Index calendar
    calendar_days: "Lu,Ma,Mi,Ju,Vi,S\xe1,Do",
    calendar_times: "Horarios: ",
    calendar_no_times: "No hay",
    calendar_date_title: "Citas del d\xeda ",
    calendar_no_dates: "No hay citas",
    btn_cancel_date: "cancelar",
    btn_edit_date: "editar",
    lbl_date_phones: "Tels:",
    new_date_text: "A\xf1adir cita el d\xeda:",
    new_date_lbl_patient: "Paciente",
    new_date_lbl_staff: "T\xe9cnico/a",
    new_date_lbl_service: "Servicio",
    new_date_lbl_date: "Fecha",
    new_date_lbl_time: "Hora",
    new_date_lbl_phone: "Tel\xe9fono",
    new_date_lbl_comment: "Comentario",
    new_date_error_empty: "Faltan datos por rellenar",
    new_date_error_server: "Error al a\xf1adir la cita",
    new_date_confirm_remove: "Eliminar cita de ",
    error_loading_date: "Error cargando datos",
    // News y Mensajes
    error_loading_news: "No se ha podido cargar las noticias.",
    lbl_loading_news: "Cargando noticias...",
    loading_reports: "Cargando datos...",
    title_news: "Noticias",
    // Reports
    reports_group_respiratory: "Respiratorios",
    reports_group_digestive: "Probi\xf3ticos",
    reports_list: "Servicios",
    reports_staff: "Equipo",
    reports_stats: "Informes SATI",
    reports_stats_iretia: "Informes IRETIA",
    reports_dosing: "Intervenciones de Pauta",
    filter_dosing_drug: "Medicamento",
    filter_dosing_patient: "Paciente",
    filter_dosing_state: "Estado",
    filter_dosing_state_all: "Todas",
    filter_dosing_state_active: "Activas",
    filter_dosing_state_deleted: "Eliminadas",
    filter_dosing_correction: "Resultado",
    filter_dosing_correction_all: "Todas",
    filter_dosing_correction_correct: "Correctas",
    filter_dosing_correction_adjusted: "Ajustadas",
    lbl_dosing_caption: "Intervenciones de pauta",
    lbl_dosing_drug: "Medicamento",
    lbl_dosing_patient: "Paciente",
    lbl_dosing_staff: "T\xe9cnico",
    lbl_dosing_doctor_doses: "Pauta m\xe9dica",
    lbl_dosing_patient_doses: "Pauta paciente",
    lbl_dosing_status: "Estado",
    dosing_delete_popup_title: "Dar de baja intervenci\xf3n de pauta",
    dosing_delete_reason_label: "Motivo de la baja",
    lbl_dosing_monthly_margin: "Margen mensual (\u20AC)",
    lbl_dosing_annual_margin: "Margen anual (\u20AC)",
    lbl_dosing_accepts: "Acepta correcci\xf3n",
    dosing_col_actions: "Acciones",
    dosing_status_over: "Sobre dosificado",
    dosing_status_under: "Sub dosificado",
    dosing_status_correct: "Correcto",
    dosing_accepts_yes: "S\xed",
    dosing_accepts_no: "No",
    dosing_confirm_delete: "\xbfEst\xe1 seguro de eliminar esta intervenci\xf3n de pauta?",
    lbl_report_staff_name: "Nombre",
    lbl_report_staff_SATI: "SATI",
    lbl_report_staff_IRETIA: "IRETIA",
    lbl_report_staff_CEPOC: "CEPOC",
    lbl_report_staff_dates_count: "Citas mostrador",
    lbl_report_staff_dates_service_count: "Citas servicio",
    lbl_report_staff_last_service: "\xdaltimo servicio",
    lbl_report_staff_last_date: "\xdaltima cita",
    lbl_report_staff_active: "Estado",
    lbl_report_staff_state_active: "Activo",
    lbl_report_staff_state_noactive: "Inactivo",
    lbl_report_type: "Servicio",
    lbl_report_date: "Fecha",
    lbl_report_name: "Nombre",
    lbl_report_staff: "T\xe9cnico",
    lbl_report_sales: "Ventas",
    lbl_report_main: "Inhalador",
    lbl_report_visit: "Visita In.",
    lbl_report_visit_real: "Visita",
    filter_service: "Servicio",
    filter_from: "Desde",
    filter_to: "Hasta",
    filter_patient: "Apellidos paciente",
    filter_btn: "Mostrar",
    filter_type_all: "Todos",
    filter_type_sati: "SATI",
    filter_type_iretia: "IRETIA",
    filter_type_cepoc: "CEPOC",
    filter_type_deleted: "Eliminados",
    report_popup_title: "Editar servicio",
    report_lbl_comment: "Comentario",
    report_lbl_sales: "Ventas",
    report_lbl_product_type: "Producto",
    report_lbl_product_name: "Nombre",
    report_lbl_product_cost: "Coste",
    report_lbl_product_quantiy: "Cantidad",
    report_btn_update: "Actualizar",
    report_btn_recover: "Recuperar",
    report_btn_delete: "Eliminar",
    report_btn_remove: "Eliminar definitivamente",
    report_btn_cancel: "Cancelar",
    report_btn_view_patient: "Informe del paciente",
    report_btn_view_doctor: "Informe derivaci\xf3n m\xe9dico",
    report_confirm_delete: "Teclee <b>eliminar</b> y pulse 'Eliminar':",
    report_confirm_delete_text: "eliminar",
    report_confirm_remove: "Teclee <b>eliminar definitivamente</b> y pulse 'Eliminar definitivamente':",
    report_confirm_remove_text: "eliminar definitivamente",
    report_sale_remove: "Quitar",
    report_sale_add: "A\xf1adir",
    // Pacientes
    patients_list: "Consulta",
    patients_followup: "Seguimiento",
    filter_patient_name: "Apellidos del paciente",
    filter_patient_order: "Ordenar por",
    filter_patient_order_name: "Apellidos",
    filter_patient_order_next_visit: "Pr\xf3xima visita",
    col_patient_name: "Paciente",
    col_patient_com_mode: "Comunicaciones",
    col_patient_contact: "Contacto",
    col_patient_lng: "Idioma",
    col_patient_visits: "Visitas",
    col_patient_next_visit: "Pr\xf3xima visita",
    patient_contact_email: "Email",
    patient_contact_call: "Llamada",
    patient_contact_sms: "SMS",
    patient_tab_basic: "Datos b\xe1sicos",
    patient_tab_com: "Comunicaciones",
    patient_tab_clinic: "M\xe9dico",
    patient_popup_title: "Editar paciente",
    patient_lbl_dni: "DNI",
    patient_lbl_name: "Nombre",
    patient_lbl_surname_1: "Primer apellido",
    patient_lbl_surname_2: "Segundo apellido",
    patient_lbl_date: "Fecha de nacimiento",
    patient_lbl_sex: "Sexo",
    patient_lbl_smoker: "Fumador",
    patient_lbl_town: "Poblaci\xf3n",
    patient_lbl_postal: "C\xf3digo postal",
    patient_lbl_com_mode: "Comunicaciones",
    patient_lbl_phone: "Tel\xe9fono (llamada)",
    patient_lbl_mobile: "Tel\xe9fono (SMS)",
    patient_lbl_email: "Email",
    patient_lbl_language: "Idioma",
    patient_lbl_doctor_genere: "Dr./Dra.",
    patient_lbl_doctor: "M\xe9dico de cabecera",
    patient_lbl_center: "Centro m\xe9dico",
    patient_lbl_comment: "Posibles sustituciones a la derivaci\xf3n por flujo",
    patient_value_yes: "S\xed",
    patient_value_no: "No",
    patient_value_man: "Masculino",
    patient_value_woman: "Femenino",
    patient_value_dr: "Doctor",
    patient_value_dra: "Doctora",
    patient_btn_delete: "Eliminar paciente",
    patient_btn_new: "Nuevo paciente",
    patient_btn_add: "Registrar paciente",
    patient_btn_update: "Actualizar datos",
    patient_btn_cancel: "Cancelar",
    patient_btn_history: "Ver historial",
    patient_confirm_delete: "\xa1Atenci\xf3n! Utilice esta opci\xf3n s\xf3lo si es un paciente de pruebas. Para confirmar, teclee <b>eliminar</b> y pulse 'Eliminar':",
    patient_confirm_delete_text: "eliminar",
    // Sincronización
    syncro_lbl_data: "Datos almacenados localmente",
    syncro_lbl_value: "Total",
    syncro_data_staff: "Equipo de la farmacia",
    syncro_data_drugs: "Medicamentos",
    syncro_data_days: "D\xedas de servicio",
    syncro_data_products: "Productos",
    syncro_data_services: "Servicios",
    syncro_lbl_date: "\xdaltima actualiaci\xf3n",
    syncro_lbl_services: "Lista de servicios pendientes",
    syncro_data_services_none: "Ninguno",
    btn_syncro_now: "Sincronizar ahora",
    // stats
    btn_stats_print: "Imprimir",
    stats_title_report: "Servicio de Acompa\xf1amiento en Terapia Inhalada",
    stats_from: "Informes desde ",
    stats_to: " hasta ",
    stats_financial_title: "Datos financieros econ\xf3micos",
    stats_visit_all: "Todas las visitas",
    stats_visit_1: "Primera visita",
    stats_visit_2: "Segunda visita",
    stats_visit_3: "Tercera visita y posteriores",
    stats_title_services: "Servicios",
    stats_title_time: "Duraci\xf3n",
    stats_title_time_per: "Duraci\xf3n por servicio",
    stats_title_sales: "Ventas",
    stats_title_sales_per: "Ventas por servicio",
    stats_prescription: "Abordajes",
    stats_title_prescription: "Servicios con al menos un abordaje",
    stats_title_prescription_per: "% de servicios",
    stats_sales: "Productos vendidos",
    stats_title_quantity: "Cantidad",
    stats_title_total: "Total",
    stats_all_staff: "Total",
    stats_farmaval: "Media Farmaval",
    chart_services: "Servicios totales",
    chart_time_avg: "Tiempo medio por servicio",
    chart_prescriptions: "Abordajes (ventas)",
    chart_prescriptions_service: "Abordajes por servicio",
    chart_media: "Farmaval: Media",
    chart_best: "Farmaval: Mejores",
    chart_pharm: "Farmacia",
    chart_visits: "Todas las visitas",
    chart_visit_1: "Primera visita",
    chart_visit_2: "Segunda visita",
    chart_visit_3: "Tercera visita y posteriores",
    stats_col_visits: "Visitas",
    stats_col_staff: "Equipo",
    stats_col_product: "Producto",
    stats_col_indicator: "Indicador",
    stats_col_error: "Error",
    stats_dosing_title: "Intervenciones de pauta",
    stats_dosing_accepted_subtitle: "Pautas aceptadas por los pacientes",
    stats_dosing_missing_subtitle: "Pautas no aceptadas por los pacientes",
    stats_dosing_item: "Item",
    stats_dosing_value: "Valor",
    stats_dosing_corrections: "N\xfamero de intervenciones de pauta",
    stats_dosing_monthly_revenue: "Facturaci\xf3n total mensual",
    stats_dosing_monthly_margin: "Margen total mensual",
    stats_dosing_annual_revenue: "Facturaci\xf3n anualizada",
    stats_dosing_annual_margin: "Margen anualizado",
    stats_dosing_top_drugs: "Medicamentos principales",
    stats_dosing_drug_name: "Medicamento",
    stats_dosing_drug_format: "Formato",
    stats_dosing_drug_monthly_revenue: "Facturaci\xf3n mensual",
    stats_dosing_drug_monthly_margin: "Margen mensual",
    stats_dosing_drug_annual_revenue: "Facturaci\xf3n anualizada",
    stats_dosing_drug_annual_margin: "Margen anualizado",
    stats_medical_title: "Datos asistenciales",
    stats_technique: "Mejora en la t\xe9cnica inhalada",
    stats_asma: "Datos de asma",
    stats_asma_kids: "Datos de asma infantil",
    stats_epoc: "Datos de EPOC",
    stats_aco: "Datos de ACO",
    stats_medical_services: "N\xfamero de servicios",
    stats_points_asma: "Puntuaci\xf3n media<br><small>5 mal control -> 25 buen control</small>",
    stats_points_asma_kids: "Puntuaci\xf3n media<br><small>0 mal control -> 27 buen control</small>",
    stats_points_epoc: "Puntuaci\xf3n media<br><small>40 impacto muy alto -> 0 impacto bajo</small>",
    stats_points_aco: "Puntuaci\xf3n media<br><small>40 impacto muy alto -> 0 impacto bajo</small>",
    stats_control_perfect: "Control total",
    stats_control_good: "Control bueno",
    stats_control_bad: "No controlado",
    stats_control_ok: "Controlado",
    stats_control_ko: "No controlado",
    stats_impact_low: "Impacto bajo",
    stats_impact_middle: "Impacto medio",
    stats_impact_high: "Impacto alto",
    stats_impact_higher: "Impacto muy alto",
    stats_errors: "Errores m\xe1s comunes",
    stats_medical_visits: "Visitas",
    stats_medical_visit_1: "Visita 1\xaa",
    stats_medical_visit_2: "Visita 2\xaa",
    stats_medical_visit_3: "Visita >2\xaa",
    stats_medical_improvment: "Mejora",
    stats_medical_quantity: "Cantidad",
    stats_medical_info: "Los c\xe1lculos de control de enfermedad se realizan s\xf3lo con los datos de la tres primeras visitas. Los resultados de las siguientes visitas de seguimiento no se tienen en cuenta.",
    stats_technique_pharm: "Media de errores en t\xe9cnica",
    stats_technique_media: "Media Farmaval",
    stats_help_chart_services: "Compara el n\xba de servicios SATI de la farmacia con la media y los mejores de Farmaval, por tipo de visita.",
    stats_help_chart_times: "Tiempo medio por servicio en minutos (m\xedn. 10 min por servicio). Menor tiempo = mejor en la columna Mejores.",
    stats_help_dosing_accepted: "Impacto econ\xf3mico de correcciones de pauta aceptadas (infra-dosificaci\xf3n): total mensual y proyecci\xf3n anual (\xd712).",
    stats_help_dosing_missing: "Mismo c\xe1lculo para pautas no aceptadas: oportunidad econ\xf3mica no capturada.",
    stats_help_financial_visit: "Por empleado: n\xba servicios, duraci\xf3n total y media, ventas totales y por servicio. Fila Total = farmacia. Filtrado por el tipo de visita del t\xedtulo.",
    stats_help_chart_prescriptions: "Compara ventas totales (\u20AC) asociadas a servicios SATI vs media y mejores Farmaval, por visita.",
    stats_help_chart_prescriptions_service: "Compara ventas medias por servicio (\u20AC) vs media y mejores Farmaval, por visita.",
    stats_help_prescriptions: "Servicios con al menos una venta registrada y % sobre el total de servicios del periodo (todas las visitas).",
    stats_help_sales: "Productos vendidos en servicios SATI: unidades e importe (\u20AC), ordenados por total.",
    stats_help_technique: "Media de errores de t\xe9cnica por visita y % de mejora al bajar errores entre visitas. Compara farmacia vs media Farmaval.",
    stats_help_asma: "Asma adulta (\u226512): n\xba servicios, puntuaci\xf3n media ACT y % control total (25), bueno (20\u201324) y no controlado (5\u201319) por visita.",
    stats_help_asma_kids: "Asma infantil (<12): n\xba servicios, puntuaci\xf3n media C-ACT y % controlado (\u226520) / no controlado (0\u201319) por visita.",
    stats_help_epoc: "EPOC: n\xba servicios, puntuaci\xf3n media CAT y % por impacto (bajo 0\u201310, medio 11\u201320, alto 21\u201330, muy alto 31\u201340).",
    stats_help_aco: "ACO: misma lectura que EPOC con puntuaci\xf3n CAT y tramos de impacto.",
    stats_help_errors: "Los 8 errores de t\xe9cnica inhalatoria m\xe1s frecuentes en el periodo (solo servicios con errores detectados).",
    // stats IRETIA
    stats_pharm: "Farmacia",
    stats_farmaval: "Farmaval",
    stats_iretia_title_report: "Servicio de intervenci\xf3n r\xe1pida en terapia inhalada aguda",
    stats_iretia_title_1: "Datos generales",
    stats_iretia_title_2: "Perfil pacientes",
    stats_iretia_title_3: "Diagn\xf3sticos",
    stats_iretia_title_4: "Inahaladores m\xe1s dispensados",
    stats_iretia_title_5: "Errores m\xe1s comunes",
    stats_iretia_title_6: "Prestaci\xf3n de servicio por miembro del equipo",
    stats_iretia_col_1: "Mi farmacia",
    stats_iretia_col_2: "Media farmacias Farmaval",
    stats_iretia_col_3: "Farmacia m\xe1s activa",
    stats_iretia_1: "N\xfamero servicios IRETIA prestados",
    stats_iretia_2: "Tiempo medio invertido por servicio (minutos)",
    stats_iretia_3: "Total ventas asociadas servicio",
    stats_iretia_4: "Media de ventas por servicio",
    stats_iretia_5: "Servicios con ventas asociadas",
    stats_iretia_6: "Media de errores",
    stats_iretia_7: "Servicios con al menos 1 error en la t\xe9cnica",
    stats_iretia_8: "Valoraci\xf3n muy \xfatil del servicio",
    stats_iretia_9: "Valoraci\xf3n compromiso muy alto de la farmacia",
    stats_iretia_8_3: "No lo sabe",
    stats_iretia_8_0: "Bronquitis aguda",
    stats_iretia_8_7: "Bronquitis asm\xe1tica",
    stats_iretia_8_1: "Neumon\xeda",
    stats_iretia_8_2: "Covid o Post Covid",
    stats_iretia_8_5: "Cardiovascular",
    stats_iretia_8_9: "Resfriado com\xfan",
    stats_iretia_8_10: "Gripe",
    stats_iretia_8_6: "Otro",
    stats_iretia_9_1: "Mujeres",
    stats_iretia_9_2: "Media edad",
    stats_iretia_9_3: "Fumadores",
    stats_iretia_9_4: "Ex fumador",
    stats_iretia_9_5: "Fumador pasivo",
    stats_iretia_9_6: "No fumador",
    stats_iretia_first: "1\xba",
    stats_iretia_second: "2\xba",
    stats_iretia_third: "3\xba",
    stats_iretia_team_1: "Servicios",
    stats_iretia_team_2: "Tiempo medio",
    stats_iretia_team_3: "Ventas",
    stats_iretia_team_4: "Media de ventas",
    stats_iretia_team_5: "Servicios con ventas",
    stats_iretia_products: "Productos vendidos",
    stats_iretia_product_qty: "Cantidad",
    stats_iretia_product_total: "Total",
    // ******************************************
    // Settings
    settings_info_drugs: "Gesti\xf3n de productos recomendados para los servicios.",
    settings_info_calendar: "Selecci\xf3n de d\xedas h\xe1biles por defecto para la realizaci\xf3n de servicios.",
    settings_info_syncro: "Informaci\xf3n sobre los datos guardados localmente.",
    settings_info_pharm: "Opciones generales relativas al aplicativo y a la farmacia.",
    settings_lbl_signature: "Firma del titular",
    settings_lbl_version: "Versi\xf3n aplicativo",
    settings_lbl_pharm: "Farmacia",
    settings_lbl_disabled: "En desarrollo",
    settings_lbl_noactive: "No activado",
    error_loading_pharm: "Problema al cargar los datos de la farmacia",
    no_signature_msg: "El sistema no dispone de una firma del titular de la farmacia, necesaria para firmar los informes.<br><br/>Puede establecerse desde la secci\xf3n de configuraci\xf3n.",
    no_passwords_msg: "Falta la contrase\xf1a de acceso. Por favor, establezca la contrase\xf1a desde la secci\xf3n de configuraci\xf3n.",
    no_signature_passwords_msg: "El sistema no dispone de una firma del titular de la farmacia, necesaria para firmar los informes, ni tampoco de contrase\xf1a de acceso.<br><br/>Pueden establecerse desde la secci\xf3n de configuraci\xf3n.",
    settings_btn_new_signature: "Nueva firma",
    signature_pharm_title: "Firma del titular de la farmacia",
    settings_password_public_lbl: "Contrase\xf1a de acceso",
    settings_password_public_info: "Est\xe1 asociada al usuario/email de la farmacia y permite acceder al aplicativo y realizar servicios.",
    warning_nopassword: "\xa1Atenci\xf3n! no hay contrase\xf1a.",
    btn_new_password: "Establecer contrase\xf1a",
    btn_change_password: "Cambiar contrase\xf1a",
    new_password_must_1: "M\xe1s de 7 car\xe1cteres.",
    new_password_must_2: "Incluir letras.",
    new_password_must_3: "Incluir n\xfameros.",
    new_password_must_4: "Incluir s\xedmbolos.",
    new_password_must_5: "Confirmar contrase\xf1a.",
    new_password_value: "Nueva contrase\xf1a",
    new_password_repeat: "Confirmar contrase\xf1a",
    new_password_public_title: "Cambiar la contrase\xf1a de t\xe9cnicos",
    new_password_error: "Error al intentar asignar la contrase\xf1a. Por favor, int\xe9ntalo de nuevo.",
    new_password_notallowed: "Un usuario t\xe9cnico no puede cambiar las contrase\xf1as. Por favor, inicie sesi\xf3n como administrador.",
    // Service
    signature_title_modal: "Recogida de datos para la prestaci\xf3n del servicio SATI",
    signature_text_check1: "AUTORIZO el uso de mis datos para la prestaci\xf3n del servicio Acompa\xf1amiento en Terapia Inhalada.",
    signature_text_check2: "AUTORIZO el uso de mis datos para la realizaci\xf3n de comunicaciones telem\xe1ticas (SMS, mensajes, E-mail, etc.)",
    signature_text_check3: "AUTORIZO el uso de mis datos para la realizaci\xf3n de estudios de investigaci\xf3n asistencial.",
    signature_text_check4: "AUTORIZO a la farmacia a compartir con el m\xe9dico que me trata la informaci\xf3n sobre el tratamiento inhalado que tomo con el fin de mejorar mis resultados terap\xe9uticos.",
    signature_image_title_modal: "Consentimiento expl\xedcito para la publicaci\xf3n y el tratamiento de im\xe1genes general",
    signature_image_radio1: "AUTORIZO el uso de las im\xe1genes",
    signature_image_radio2: "NO AUTORIZO el uso de las im\xe1genes.",
    signature_label_patient: "Al ser menor, escribe el nombre de la persona responsable",
    signature_btn_clear: "Empezar de nuevo",
    signature_btn_ok: "Aceptar",
    signature_btn_cancel: "Cancelar",
    signature_error: "No se ha podido almacenar la nueva firma, por favor int\xe9ntelo de nuevo.",
    service_error_unknown: "El servicio no existe",
    service_error_loading: "Error cargando servicios",
    service_error_patient: "Error cargando formulario de paciente",
    service_error_staff: "Error cargando datos de los responsables",
    service_error_service: "Error cargando datos del servicio",
    service_btn_cancel: "Cancelar servicio",
    service_btn_prev: "Atr\xe1s",
    service_btn_next: "Siguiente",
    tab_start_title: "Inicio de servicio",
    tab_start_info: "Seleccione el t\xe9cnico que realizar\xe1 el servicio y rellene la ficha del paciente. Si el paciente ya est\xe1 registrado puede buscarlo por el DNI o sus apellidos.",
    tab_start_info_iretia: "Seleccione el t\xe9cnico que realizar\xe1 el servicio y rellene los datos del paciente. En caso de cesi\xf3n de derechos de imagen, rellene el DNI, nombre y apellidos.",
    tab_start_staff_info: "T\xe9cnico del servicio",
    lbl_question_cancel: "\xbfSeguro que quiere cancelar el servicio? No se guardar\xe1 ning\xfan dato.",
    lbl_question_new: "Escriba el nombre del nuevo t\xe9cnico:",
    lbl_question_update: "Escriba el nuevo nombre del t\xe9cnico:",
    lbl_question_delete: "\xbfSeguro que quiere eliminar el t\xe9cnico seleccionado?",
    btn_staff_delete: "Eliminar seleccionado",
    btn_staff_update: "Modificar",
    btn_staff_new: "Nuevo",
    tab_start_patient_info: "Ficha del paciente",
    lbl_patient_search: "Buscando paciente...",
    lbl_patient_new: "Nuevo paciente",
    lbl_patient_error: "Error en servidor",
    lbl_patient_dni: "DNI",
    lbl_patient_name: "Nombre",
    lbl_patient_surname_1: "Primer apellido",
    lbl_patient_surname_2: "Segundo apellido",
    lbl_patient_date: "Fecha de nacimiento",
    lbl_patient_age: "Edad",
    lbl_patient_sex: "Sexo",
    lbl_patient_smoke: "Fumador",
    lbl_patient_extra: "Datos s\xf3lo si el paciente cede derechos de imagen",
    options_patient_sex: "Mujer/1,Hombre/0",
    options_patient_smoke: "No/0,S\xed/1",
    lbl_patient_studies: "Estudios",
    lbl_patient_tsi: "TSI",
    options_patient_studies: "Sin estudios/0,B\xe1sicos/1,Bachillerato/2,Grado t\xe9cnico/3,Universitarios/4",
    lbl_patient_town: "Poblaci\xf3n",
    lbl_patient_postal: "C\xf3digo postal",
    lbl_patient_phone: "Tel\xe9fono fijo (llamada)",
    lbl_patient_mobile: "M\xf3vil (SMS)",
    lbl_patient_contact: "Tel\xe9fono M\xf3vil",
    lbl_patient_email: "Email",
    lbl_patient_com_mode: "Comunicaciones",
    lbl_patient_lang: "Idioma",
    options_patient_com_mode: "Por email/0,Por llamada/1,Por SMS/2",
    options_patient_lang: "Castellano/es,Catal\xe0/ca",
    lbl_patient_doctor_genere: "Dr/Dra",
    options_patient_doctor_genere: "Dr./0,Dra./1",
    lbl_patient_doctor: "M\xe9dico de cabecera",
    lbl_patient_center: "Centro m\xe9dico",
    lbl_patient_comment: "Posibles sustituciones a la derivaci\xf3n por flujo",
    lbl_patient_sign: "Firma del paciente",
    section_patient_title: "Datos b\xe1sicos del paciente",
    section_patient_info: "Rellene los datos si es nuevo paciente o actual\xedzalos si es necesario",
    form_error_staff: "Seleccione tu nombre como responsable del servicio",
    form_error_required: "Faltan datos por rellenar",
    form_error_pattern: "El formato no es el correcto",
    form_error_contact: "Debe rellenar el dato de contacto.",
    form_error_options: "Hay preguntas del cuestionario sin responder.",
    // 0.7.3
    title_chat: "Contacto",
    info_chat: "Puede enviarnos un correo directamente desde aqu\xed.",
    placeholder_chat: "Mensaje a enviar",
    btn_chat_send: "Enviar",
    email_ok: "Gracias, le responderemos lo antes posible.",
    email_error: "No hemos podido enviar el correo, por favor int\xe9ntelo de nuevo o p\xf3ngase en contacto con nosotros a trav\xe9s de farmaval.net",
    // 0.7.5
    rep_title_change: "Servicio a: ",
    rep_comment: "Comentario",
    rep_btn_patient: "Informe paciente",
    rep_btn_doctor: "Informe m\xe9dico",
    rep_btn_delete: "Eliminar servicio",
    rep_btn_remove: "Eliminar definitivamente",
    rep_btn_confirm: "Confirmar eliminar",
    rep_btn_save: "Actualizar",
    rep_btn_restore: "Restaurar",
    rep_sales: "Productos vendidos",
    rep_products: "Productos",
    rep_prod_name: "Nombre",
    rep_prod_cost: "Precio",
    rep_prod_qty: "Cantidad",
    rep_prod_add: ">>",
    rep_prod_other: "Otro",
    rep_result_error: "Error realizando operaci\xf3n",
    rep_result_notallowed: "S\xf3lo el titular puede eliminar registros.",
    service_error_loading_data: "Ha habido un error actualizando los datos para inciar el servicio.",
    service_error_local_data: "No se han podido cargar los datos para iniciar el servicio. Aseg\xfarese que hay conexi\xf3n a Internet y vuelva a intentarlo.",
    service_warning_local_data: "Los datos para iniciar el servicio puede que est\xe9n desactualizados",
    service_online: "Conectado",
    service_offline: "Sin conexi\xf3n",
    end_reports_question: "Confirme que se cierra el servicio.",
    end_error_reports: "Problema al generar informes y almacenar el servicio.",
    end_error_reports_backup: "Problema al guardar el servicio. Se va a almacenar de forma local para no perder los datos.<br><br>Puede realizar la sincronizaci\xf3n con el servidor desde la secci\xf3n de configuraci\xf3n.",
    // Probiomentor — Material divulgativo y formación
    probio_formation_btn: "Acceder a Probio Experts",
    probio_formation_sub: "Formaci\xf3n especializada en probi\xf3ticos",
    probio_material_title: "Material Probio Mentor",
    probio_material_subtitle: "Descarga flyers y posts para redes sociales",
    // Mensajes de Probio
    probio_loading: "Generando acceso seguro...",
    error_probio_link: "No se pudo generar el acceso a Probio. Por favor, intente nuevamente o contacte a soporte.",
    error_probio_service: "El servicio Probio no est\xe1 activo para su farmacia.",
    error_session: "Error de sesi\xf3n. Por favor, vuelva a iniciar sesi\xf3n.",
    error_server: "Error de conexi\xf3n con el servidor. Por favor, intente nuevamente.",
    // Probiomentor — Servicio de abordaje (Etapa 08)
    probio_step_staff_title: "\xbfQui\xe9n realiza el abordaje?",
    probio_step_indication_title: "\xbfCu\xe1l es la indicaci\xf3n del paciente?",
    probio_step_probiotics_title: "Probi\xf3ticos con evidencia cient\xedfica",
    probio_see_stats: "Ver mis estad\xedsticas",
    probio_search_placeholder: "Buscar indicaci\xf3n...",
    probio_in_stock: "Preferente",
    probio_evidence: "Evidencia",
    probio_dosage: "Pauta",
    probio_accepted: "\u2713 Abordaje Aceptado",
    probio_rejected: "\u2717 Abordaje No Aceptado",
    probio_congrats_accepted: "\xa1Excelente abordaje! El paciente lo ha aceptado.",
    probio_congrats_rejected: "Abordaje registrado. El paciente no lo ha aceptado en esta ocasi\xf3n.",
    probio_new_advice: "Nuevo abordaje",
    probio_filter_all: "Todas las categor\xedas",
    probio_select_indication: "Selecciona una indicaci\xf3n...",
    probio_search_btn: "Buscar Probi\xf3ticos con Evidencia Cient\xedfica",
    // Probiomentor — Consultas (Etapa 09)
    probio_reports_tab: "Servicios Probiomentor",
    probio_team_tab: "Informe Probiomentor",
    probio_team_subtab_services: "Servicios",
    probio_team_subtab_consultas: "Consultas",
    probio_team_services_title: "Servicios Probiomentor - Equipo",
    probio_team_services_help: "Desglose por miembro del equipo: abordajes, aceptaci\xf3n, tiempo medio y ventas.",
    probio_team_col_total: "Total abordajes",
    probio_team_col_accepted: "Aceptados",
    probio_team_col_rejected: "No aceptados",
    probio_team_col_rate: "% Aceptaci\xf3n",
    probio_team_col_time: "Tiempo medio (min)",
    probio_team_col_sales: "Ventas (\u20AC)",
    probio_team_col_avg_sale: "Media ventas (\u20AC)",
    // Datos generales (comparativa con la media y el mejor de Farmaval)
    probio_services_stats_title: "Datos generales",
    probio_services_stats_help: "Compara los indicadores clave de tu farmacia con la media y el mejor valor de Farmaval.",
    probio_services_stats_col_indicator: "Indicador",
    probio_services_stats_col_pharmacy: "Tu farmacia",
    probio_services_stats_col_average: "Promedio farmacias",
    probio_services_stats_col_best: "Mejor farmacia",
    probio_dg_services: "Servicios prestados",
    probio_dg_services_per_day: "Media de servicios por d\xeda",
    probio_dg_services_per_person: "Media de servicios por persona del equipo",
    probio_dg_avg_time: "Tiempo medio (min)",
    probio_dg_total_sales: "Total ventas (\u20AC)",
    probio_dg_avg_sale: "Media de ventas por servicio (\u20AC)",
    probio_dg_with_sales: "Abordajes aceptados (%)",
    // Indicaciones más frecuentes
    probio_indications_title: "Indicaciones m\xe1s frecuentes",
    probio_indications_help: "Indicaciones m\xe1s consultadas en tu farmacia, con su peso frente a la media de Farmaval.",
    probio_indications_col_name: "Indicaci\xf3n",
    probio_indications_col_pharmacy: "Tu farmacia (%)",
    probio_indications_col_average: "Promedio farmacias (%)",
    probio_indications_empty: "Sin datos en el periodo seleccionado.",
    probio_indications_others: "Otros",
    // Probióticos más dispensados
    probio_top_title: "Probi\xf3ticos m\xe1s dispensados",
    probio_top_help: "Los tres probi\xf3ticos m\xe1s recomendados en tu farmacia.",
    probio_top_col_rank: "Posici\xf3n",
    probio_top_col_pharmacy: "Tu farmacia",
    // Probióticos vendidos
    probio_products_title: "Probi\xf3ticos vendidos",
    probio_products_help: "Probi\xf3ticos vendidos por tu farmacia.",
    probio_products_col_product: "Producto",
    probio_products_col_quantity: "Cantidad",
    probio_products_col_total: "Total (\u20AC)",
    probio_products_total_row: "Total",
    probio_products_empty: "Sin ventas registradas en el periodo seleccionado.",
    // Baja lógica de servicios del historial Probiomentor
    probio_history_col_actions: "Acciones",
    probio_history_deleted_badge: "Dado de baja",
    probio_history_delete_popup_title: "Dar de baja servicio Probiomentor",
    probio_history_delete_popup_text: "El servicio dejar\xe1 de contar en los listados y las estad\xedsticas. Esta acci\xf3n no borra el registro, solo lo marca como dado de baja.",
    probio_history_delete_reason_label: "Motivo de la baja",
    probio_history_deleted_ok: "Servicio dado de baja correctamente."
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"7s2zc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "page_text_ca", ()=>page_text_ca);
const page_text_ca = {
    // Formació (M10)
    nav_formacion: "Formaci\xf3",
    formacion_title: "Formaci\xf3",
    formacion_person_label: "Persona:",
    formacion_change: "Canviar",
    formacion_who: "Qui ets?",
    formacion_who_hint: "El teu progr\xe9s i les teves avaluacions es guarden al teu nom. Tria el teu nom de la llista de l'equip.",
    formacion_no_staff: "La teva farm\xe0cia encara no t\xe9 equip registrat. Demana a Farmaval que el doni d'alta.",
    formacion_empty: "Encara no hi ha contingut disponible en aquesta carpeta.",
    formacion_home: "Inici",
    formacion_folder: "Carpeta",
    formacion_block: "Bloc",
    formacion_locked: "Bloquejat",
    formacion_seen: "Vist",
    formacion_close: "Tancar",
    formacion_open_tab: "Obrir en pestanya",
    formacion_kind_video: "V\xeddeo",
    formacion_kind_link: "Enlla\xe7",
    formacion_kind_template: "Document",
    formacion_kind_image: "Imatge",
    formacion_quiz_btn: "Fer q\xfcestionari",
    formacion_quiz_send: "Enviar respostes",
    formacion_quiz_result: "La teva nota",
    formacion_quiz_best: "Millor nota",
    formacion_quiz_back: "Tornar",
    formacion_quiz_unanswered: "Respon totes les preguntes abans d'enviar.",
    taller_inhaladores_name: "Taller d'Inhaladors",
    taller_inhaladores_desc: "Formaci\xf3 pr\xe0ctica en dispositius d'inhalaci\xf3",
    taller_insulinas_name: "Taller d'Insulines",
    taller_insulinas_desc: "Formaci\xf3 pr\xe0ctica en insulines i plomes",
    formacion_mentoring_btn: "Agendar mentoria despr\xe9s de la formaci\xf3",
    formacion_mentoring_confirm: "Avisar el vostre mentor que voleu agendar la mentoria d'aquest bloc?",
    formacion_mentoring_sent: "Fet! El teu mentor ha estat avisat i coordinar\xe0 la sessi\xf3 amb vosaltres.",
    formacion_mentoring_already: "Ja hi havia una sol\xb7licitud pendent per a aquest bloc: el vostre mentor ja est\xe0 avisat.",
    formacion_result_title: "El meu resultat ProBioMentor",
    formacion_result_pending: "pendent",
    formacion_result_noquiz: "sense examen",
    formacion_result_diploma: "Descarregar diploma d'expert",
    formacion_result_certificate: "Descarregar certificat d'aprofitament",
    formacion_result_retake_hint: "Pots repetir l'examen del bloc susp\xe8s per pujar la teva mitjana i aconseguir el diploma (repesca).",
    formacion_result_incomplete: "Completa l'avaluaci\xf3 de tots els blocs per obtenir el teu diploma o certificat.",
    // Servicios
    sati_name: "SATI",
    sati_desc: "Servei d'acompanyament en ter\xe0pia inhalada",
    satib_name: "SATIB",
    satib_desc: "Servei b\xe0sic d'acompanyament en ter\xe0pia inhalada",
    iretia_name: "IRETIA",
    iretia_desc: "Intervenci\xf3 r\xe0pida en ter\xe0pia inhalada aguda",
    cepoc_name: "CEPOC",
    cepoc_desc: "Cribratge de Malaltia Pulmonar Obstructiva MPOC",
    probio_name: "ProbioMentor",
    probio_desc: "Recomanaci\xf3 de probi\xf2tics basada en evid\xe8ncia",
    sati_test_name: "SATI Test",
    sati_test_desc: "Servicio en desarrollo",
    rcm_name: "RCM",
    rcm_desc: "Control de risc cardio metab\xf2lic",
    adir_name: "ADIR",
    adir_desc: "Ajust de dosi en insufici\xe8ncia renal",
    // Navigation
    nav_home: "Inici",
    nav_patients: "Pacients",
    nav_services: "Serveis",
    nav_profile: "Perfil",
    nav_calendar: "Agenda",
    nav_reports: "Consultes",
    nav_language: "Idioma",
    nav_language_ca: "Catal\xe0",
    nav_language_es: "Espa\xf1ol",
    nav_logout: "Tancar sessi\xf3",
    nav_owner: "Mode titular",
    nav_marketing: "Material divulgatiu",
    nav_cart: "Reposici\xf3",
    // Carret de reposició (FA-01 a FA-04)
    cart_tab_current: "El meu carret",
    cart_tab_orders: "Les meves comandes",
    cart_empty: "El teu carret \xe9s buit. Els productes de Farmaval que venguis durant els serveis s'hi afegiran autom\xe0ticament, i tamb\xe9 hi pots afegir els que vulguis des del cat\xe0leg.",
    cart_add_label: "Afegir producte del cat\xe0leg",
    cart_add_price: "Preu",
    cart_btn_add: "Afegir",
    cart_lbl_product: "Producte",
    cart_lbl_ref: "Refer\xe8ncia",
    cart_lbl_units: "Unitats",
    cart_lbl_price: "Preu",
    cart_lbl_iva: "IVA",
    cart_lbl_total: "Total",
    cart_lbl_order: "Comanda",
    cart_lbl_date: "Data",
    cart_lbl_shipping: "Enviament",
    cart_summary_title: "Resum de la comanda",
    cart_subtotal: "Base imposable",
    cart_shipping: "Despeses d'enviament",
    cart_total: "Total",
    cart_free: "Gratis",
    cart_btn_submit: "Tramitar comanda",
    cart_btn_remove: "Treure",
    cart_confirm_remove: "Vols treure aquest producte del carret?",
    cart_confirm_submit: "Vols tramitar la comanda de reposici\xf3?",
    cart_submitting: "Tramitant...",
    cart_free_shipping_hint: "Et falten {amount} \u20AC (sense IVA) per a l'enviament gratu\xeft.",
    cart_free_shipping_ok: "La teva comanda t\xe9 enviament gratu\xeft.",
    cart_order_placed: "Comanda {number} tramitada correctament.",
    cart_orders_empty: "Encara no has tramitat cap comanda de reposici\xf3.",
    cart_order_by_farmaval: "Tramitada per Farmaval",
    cart_error_generic: "No s'ha pogut completar l'operaci\xf3. Torna-ho a provar.",
    marketing_root_label: "Inici",
    marketing_empty: "Encara no hi ha material divulgatiu disponible.",
    // Login
    login_title: "Inici de sessi\xf3",
    login_user_placeholder: "Usuari o email",
    login_password_placeholder: "Contrasenya",
    login_button: "Autentificar",
    login_error_user: "Usuari o contrasenya no v\xe0lids.",
    login_error_blocked: "L'acc\xe9s d'aquesta farm\xe0cia est\xe0 desactivat. Posa't en contacte amb Farmaval.",
    login_error_server: "Error de conexi\xf3.",
    // Accés del mentor a les seves farmàcies
    mentor_pharmacies_title: "Tria una farm\xe0cia",
    mentor_pharmacies_greeting: "Hola, {name}. Entrar\xe0s a l'app com la farm\xe0cia que tri\xefs.",
    mentor_pharmacies_empty: "No tens farm\xe0cies assignades i confirmades.",
    mentor_pharmacy_current: "Farm\xe0cia actual",
    mentor_mirror_title: "Practicar formaci\xf3",
    mentor_mirror_info: "Farm\xe0cia mirall, sense dades de cap farm\xe0cia",
    mentor_pharmacies_back: "Tornar",
    mentor_error_access: "No tens acc\xe9s a aquesta farm\xe0cia.",
    mentor_error_pending_services: "Hi ha serveis pendents de sincronitzar. Sincronitza'ls abans de canviar de farm\xe0cia.",
    mentor_note_cart: "La comanda l'envia la farm\xe0cia.",
    mentor_note_agreement: "El contracte el signa la farm\xe0cia.",
    mentor_banner_text: "Mode mentor: est\xe0s veient {pharm} com a {name}.",
    nav_mentor_switch: "Canviar farm\xe0cia",
    login_password_forgotten: "Si ha oblidat la seva contrasenya, introdueixi la seva adre\xe7a de correu electr\xf2nic i premi [Recuperar contrasenya]. Rebr\xe0 un missatge amb un codi de recuperaci\xf3.",
    login_send_password: "Recuperar contrasenya.",
    login_error_recover: "Error en iniciar el proc\xe9s de recuperaci\xf3.",
    login_error_email: "Adre\xe7a de recuperaci\xf3 no v\xe0lida.",
    login_recover_ok: "Codi enviat a l\u2019adre\xe7a de correu electr\xf2nic.",
    update_password_title: "Actualitzar contrasenya",
    update_password_info: "Per motius de seguretat, heu de crear una contrasenya nova per accedir a l'aplicatiu.",
    update_password_placeholder: "Contrasenya nova",
    update_repassword_placeholder: "Confirma la contrasenya nova",
    update_password_button: "Actualitzar contrasenya",
    update_password_cancel: "Cancel\xb7lar",
    update_password_must_1: "Ha de contenir almenys un nombre.",
    update_password_must_2: "Ha de contenir almenys una lletra maj\xfascula.",
    update_password_must_3: "Ha de contenir almenys un s\xedmbol.",
    update_password_must_4: "Has de confirmar la contrasenya.",
    update_error: "Problema actualitzant contrasenya. Si us plau, torneu a intentar-ho abans de contactar amb Farmaval.",
    update_same: "La nova contrasenya ha de ser diferent de l'anterior.",
    update_ok_title: "Contrasenya actualitzada",
    update_ok: "La teva nova contrasenya ja est\xe0 activa. Fes-la servir la propera vegada que entris a Farmaval.",
    register_title: "Benvingut!",
    register_info: "Per registrar la vostra farm\xe0cia, si us plau, introdu\xefu un email, una contrasenya d'acc\xe9s i el codi de registre subministrat pel vostre delegat.<br><br>La contrasenya ha de:",
    register_email: "Email",
    register_password: "Contrasenya d'acc\xe9s",
    register_repassword: "Confirmar contrasenya",
    register_password_must_1: "Contenir almenys un nombre.",
    register_password_must_2: "Contenir almenys una lletra maj\xfascula.",
    register_password_must_3: "Contenir almenys un s\xedmbol.",
    register_password_must_4: "Has de confirmar la contrasenya.",
    register_pharm: "nom de la farm\xe0cia",
    register_code: "Codi de Prodeco",
    register_pharm_button: "Registrar farm\xe0cia",
    register_error_func: "S'ha produ\xeft un problema inesperat. Si us plau, poseu-vos en contacte amb Farmaval.",
    register_error_email: "El correu electr\xf2nic ja est\xe0 registrat.",
    register_error_code: "El codi no \xe9s v\xe0lid.",
    register_notify_title: "Registre correcte",
    register_notify_info: "Li hem enviat un email amb les dades de registre (comproveu la safata d'spam si no l'heu rebut). Si us plau, inicieu sessi\xf3 per continuar amb el proc\xe9s d'alta.",
    register_continue_button: "Iniciar sessi\xf3",
    alert_code_title: "Mode Titular",
    alert_code_info: "Per accedir al mode titular heu d'introduir la contrasenya:",
    alert_code_wrong: "Contrasenya incorrecta.",
    alert_code_recover: "He oblidat la contrasenya",
    alert_code_recover_info: "S'enviar\xe0 un email a l'adre\xe7a de correu del titular.",
    alert_code_recover_email: "S'ha enviat un email amb la nova contrasenya a l'adre\xe7a: ",
    alert_code_recover_error: "S'ha produ\xeft un error en enviar el correu amb la nova contrasenya.",
    // Formación
    formation_sati: "Servei SATI",
    formation_iretia: "Servei IRETIA",
    formation_cepoc: "Servei CEPOC",
    formation_all: "Sessions de valor",
    videos_label: "Videos",
    all_videos_label: "Para el responsable",
    team_videos_label: "Para el equipo",
    material_label: "Material adicional",
    video_iretia_1: "1. Taller inhaladores Presurizados.",
    video_iretia_2: "2. Taller inhaladores Camara de inhalaci\xf3n.",
    video_iretia_3: "3. Taller inhaladores polvo seco monodosis.",
    video_iretia_4: "4. Taller inhaladores polvo seco multidosis con dep\xf3sito.",
    video_iretia_5: "5. Taller de inhaladores polvo seco con bl\xedster.",
    video_iretia_6: "6. Conceptos de aerosolterapia y distribuci\xf3n de part\xedculas.",
    video_iretia_7: "7. La t\xe9cnica inhalada.",
    link_iretia_1: "https://player.vimeo.com/video/838398122",
    link_iretia_2: "https://player.vimeo.com/video/688355173",
    link_iretia_3: "https://player.vimeo.com/video/684574347",
    link_iretia_4: "https://player.vimeo.com/video/688361792",
    link_iretia_5: "https://player.vimeo.com/video/688367203",
    link_iretia_6: "https://player.vimeo.com/video/688371703",
    link_iretia_7: "https://player.vimeo.com/video/688623093",
    material_iretia_1: "1- Consenso asma pediatr\xeda 2021 REGAP.",
    material_iretia_2: "2- Dossier formativo.",
    material_iretia_3: "3- Informe dispositivos de polvo seco unidosis.",
    material_iretia_4: "4- Informe dispositivos de polvo seco multidosis.",
    material_iretia_5: "5-Informe dispositivos presurizados sin c\xe1mara.",
    material_iretia_6: "6- Informe dispositivos presurizados con c\xe1mara.",
    material_iretia_7: "7- Informe dispositivos presurizados con c\xe1mara en ni\xf1os y lactantes.",
    file_iretia_1: "https://www.farmaval.net/docs/8-%20Consenso%20asma%20pediatria%202021%20REGAP.pdf",
    file_iretia_2: "https://www.farmaval.net/docs/9-Dossier%20formativo.pdf",
    file_iretia_3: "https://www.farmaval.net/docs/iretia/ca/pols_seca_unidosis.pdf",
    file_iretia_4: "https://www.farmaval.net/docs/iretia/ca/polvo_seco_multidosis.pdf",
    file_iretia_5: "https://www.farmaval.net/docs/iretia/ca/presurizados_sin_c%C3%A1mara.pdf",
    file_iretia_6: "https://www.farmaval.net/docs/iretia/ca/presurizados_con_c%C3%A1mara.pdf",
    file_iretia_7: "https://www.farmaval.net/docs/iretia/ca/presurizados_c%C3%A1mara_lactantes.pdf",
    video_sati_1: "1. Una historia y un sue\xf1o.",
    video_sati_2: "2. \xbfPor qu\xe9 es necesario el servicio SATI?",
    video_sati_3: "3. Nuestro rol como profesionales sanitarios.",
    video_sati_4: "4. Taller inhaladores Presurizados.",
    video_sati_5: "5. Taller inhaladores Camara de inhalaci\xf3n.",
    video_sati_6: "6. Taller inhaladores polvo seco monodosis.",
    video_sati_7: "7. Taller inhaladores polvo seco multidosis con dep\xf3sito.",
    video_sati_8: "8. Taller de inhaladores polvo seco con bl\xedster.",
    video_sati_9: "9. Taller de inhaladores: Material de soporte.",
    video_sati_10: "10. Conclusiones y plan de acci\xf3n para todo el equipo.",
    video_sati_11: "11. Conceptos de aerosolterapia y distribuci\xf3n de part\xedculas.",
    video_sati_12: "12. La t\xe9cnica inhalada.",
    video_sati_13: "13. El aparato respiratorio.",
    video_sati_14: "14. Patologia respiratoria y Principales diferencias entre Asma y EPOC.",
    video_sati_15: "15. El servicio SATI definici\xf3n.",
    video_sati_16: "16. Funcionamiento de Farmaval App.",
    video_sati_17: "17. Recogida de datos generales del paciente.",
    video_sati_18: "18. SATI LOPD.",
    video_sati_19: "19. Diagnostico y farmacoterapia.",
    video_sati_20: "20. Cuestionarios de control de la patolog\xeda respiratoria.",
    video_sati_21: "21. Educaci\xf3n sanitaria sobre la patolog\xeda respiratoria.",
    video_sati_22: "22. Valoraci\xf3n de la t\xe9cnica inhalada.",
    video_sati_23: "23. Formaci\xf3n y mejora de la t\xe9cnica inhalada.",
    video_sati_24: "24. Los dispositivos de entrenamiento.",
    video_sati_25: "25. Control del flujo inspiratorio.",
    video_sati_26: "26. La prescripci\xf3n farmac\xe9utica y el talonario de prescripci\xf3n.",
    video_sati_27: "27. Prescripci\xf3n de la c\xe1mara A2A y mascarilla de inhalaci\xf3n.",
    video_sati_28: "28. Prescripci\xf3n de InmunoRespir.",
    video_sati_29: "29. Prescripci\xf3n para las mucosas orales afectadas.",
    video_sati_30: "30. Encuesta final al paciente.",
    video_sati_31: "31. Generaci\xf3n de informes y pr\xf3xima cita.",
    video_sati_32: "32. Informe de paciente.",
    video_sati_33: "33. Informe de derivaci\xf3n por flujo insuficiente.",
    video_sati_34: "34. Otros informes de derivaci\xf3n.",
    video_sati_35: "35. Ofrecimiento del servicio en el mostrador.",
    video_sati_36: "36. Programar nuevas citas en la agenda.",
    video_sati_37: "37. Registro de las prescripciones aceptadas.",
    video_sati_38: "38. Sistema de recordatorios y mensajer\xeda.",
    video_sati_39: "39. Medidas Covid.",
    video_sati_40: "40. \xbfQui\xe9n hay detr\xe1s de Farmaval?",
    video_sati_41: "41. Elecci\xf3n inhalador principal.",
    video_sati_42: "42. \xbfQue ocurre si paciente usa dos inhaladores diferentes?",
    video_sati_43: "43. Paciente EPOC e inhalador monodosis polvo seco Handihaler.",
    video_sati_44: "44. Paciente EPOC con enfisema pulmonar e inhalador de niebla fina Respimat.",
    video_sati_45: "45. Paciente Asm\xe1tico e inhalador de polvo seco Turbuhaler.",
    link_sati_1: "https://player.vimeo.com/video/684573034",
    link_sati_2: "https://player.vimeo.com/video/685392520",
    link_sati_3: "https://player.vimeo.com/video/688345206",
    link_sati_4: "https://player.vimeo.com/video/838398122",
    link_sati_5: "https://player.vimeo.com/video/688355173",
    link_sati_6: "https://player.vimeo.com/video/684574347",
    link_sati_7: "https://player.vimeo.com/video/688361792",
    link_sati_8: "https://player.vimeo.com/video/688367203",
    link_sati_9: "https://player.vimeo.com/video/688368760",
    link_sati_10: "https://player.vimeo.com/video/838405767",
    link_sati_11: "https://player.vimeo.com/video/688371703",
    link_sati_12: "https://player.vimeo.com/video/688623093",
    link_sati_13: "https://player.vimeo.com/video/688610397",
    link_sati_14: "https://player.vimeo.com/video/688626444",
    link_sati_15: "https://player.vimeo.com/video/688610899",
    link_sati_16: "https://player.vimeo.com/video/701189206",
    link_sati_17: "https://player.vimeo.com/video/684575488",
    link_sati_18: "https://player.vimeo.com/video/684576687",
    link_sati_19: "https://player.vimeo.com/video/685396491",
    link_sati_20: "https://player.vimeo.com/video/685397299",
    link_sati_21: "https://player.vimeo.com/video/685399122",
    link_sati_22: "https://player.vimeo.com/video/685399333",
    link_sati_23: "https://player.vimeo.com/video/688612675",
    link_sati_24: "https://player.vimeo.com/video/688459718",
    link_sati_25: "https://player.vimeo.com/video/688462696",
    link_sati_26: "https://player.vimeo.com/video/701189730",
    link_sati_27: "https://player.vimeo.com/video/688614103",
    link_sati_28: "https://player.vimeo.com/video/688629258",
    link_sati_29: "https://player.vimeo.com/video/688616792",
    link_sati_30: "https://player.vimeo.com/video/688617394",
    link_sati_31: "https://player.vimeo.com/video/688620317",
    link_sati_32: "https://player.vimeo.com/video/688617623",
    link_sati_33: "https://player.vimeo.com/video/688621404",
    link_sati_34: "https://player.vimeo.com/video/701190158",
    link_sati_35: "https://player.vimeo.com/video/688621835",
    link_sati_36: "https://player.vimeo.com/video/688618095",
    link_sati_37: "https://player.vimeo.com/video/688465095",
    link_sati_38: "https://player.vimeo.com/video/688466020",
    link_sati_39: "https://player.vimeo.com/video/685406481",
    link_sati_40: "https://player.vimeo.com/video/685413171",
    link_sati_41: "https://player.vimeo.com/video/838385660",
    link_sati_42: "https://player.vimeo.com/video/838386868",
    link_sati_43: "https://player.vimeo.com/video/891112561",
    link_sati_44: "https://player.vimeo.com/video/891123647",
    link_sati_45: "https://player.vimeo.com/video/891147645",
    material_sati_1: "1- Estudio EPOCONSUL.",
    material_sati_2: "2- Informe de resultados ASPIRA 2014.",
    material_sati_3: "3- Revisi\xf3n sistem\xe1tica 2016 sobre errores en terapia inhalada.",
    material_sati_4: "4- Programa SABINA sobreuso SABA.",
    material_sati_5: "5- MiniGEMA5.1.",
    material_sati_6: "6- GINA Pocket Guide 2021.",
    material_sati_7: "7- GESEPOC2021.",
    material_sati_8: "8- Consenso asma pediatr\xeda 2021 REGAP.",
    material_sati_9: "9- Dossier formativo.",
    material_sati_10: "10- Algoritmo de resistencias de In-Check Dial.",
    material_sati_11: "11- Tabla de flujos m\xednimos y \xf3ptimos por dispositivo.",
    material_sati_12: "12- Pauta InmunoRespir.",
    material_sati_13: "13- Ofrecimiento del servicio SATI.",
    material_sati_14: "14- Cuestionario para descartar Covid-19.",
    material_sati_15: "15- Proveedores de productos SATI para farmacias.",
    material_sati_16: "16- Modelo solicitud ejercicio derechos del interesado.",
    material_sati_17: "17- Consentimiento cesi\xf3n im\xe1genes y v\xeddeos pacientes SATI.",
    material_sati_18: "18- Instrucciones solicitudes del interesado en la Farmacia.",
    material_sati_19: "19- Informe del paciente.",
    material_sati_20: "20- Informe de derivaci\xf3n b\xe1sico.",
    material_sati_21: "21- Informe de derivaci\xf3n por flujo.",
    material_sati_22: "22- Infografia asma y colageno.",
    material_sati_23: "23- Tabla de flujos \xf3ptimos por dispositivo.",
    material_sati_24: "24- Elecci\xf3n inhalador principal. Castellano",
    material_sati_25: "25- Pauta InmunoRespir.",
    material_sati_26: "26- Quecetina.",
    material_sati_27: "27- Mapa mental 3 acciones inhaladores.",
    file_sati_1: "https://www.farmaval.net/docs/1-Estudio%20EPOCONSUL.pdf",
    file_sati_2: "https://www.farmaval.net/docs/2-Informe%20de%20resultados%20ASPIRA%202014.pdf",
    file_sati_3: "https://www.farmaval.net/docs/3-%20Revisi%C3%B3n%20sistematica%202016%20sobre%20errores%20en%20terapia%20inhalada.pdf",
    file_sati_4: "https://www.farmaval.net/docs/4-%20Programa%20SABINA%20sobreuso%20SABA.pdf",
    file_sati_5: "https://www.farmaval.net/docs/5-%20MiniGEMA5.1.pdf",
    file_sati_6: "https://www.farmaval.net/docs/6-%20GINA%20Pocket%20Guide%202021.pdf",
    file_sati_7: "https://www.farmaval.net/docs/7-%20GESEPOC2021.pdf",
    file_sati_8: "https://www.farmaval.net/docs/8-%20Consenso%20asma%20pediatria%202021%20REGAP.pdf",
    file_sati_9: "https://www.farmaval.net/docs/9-Dossier%20formativo.pdf",
    file_sati_10: "https://www.farmaval.net/docs/10-%20Algoritmo%20de%20resistencias%20de%20In-Check%20Dial.pdf",
    file_sati_11: "https://www.farmaval.net/docs/11-%20Tabla%20de%20flujos%20m%C3%ADnimos%20y%20%C3%B3ptimos%20por%20dispositivo.pdf",
    file_sati_12: "https://www.farmaval.net/docs/12-%20Pauta%20InmunoRespir.pdf",
    file_sati_13: "https://www.farmaval.net/docs/13-%20Oferiment%20del%20servei%20SATI.pdf",
    file_sati_14: "https://www.farmaval.net/docs/14-%20Cuestionario%20para%20descartar%20Covid-19.pdf",
    file_sati_15: "https://www.farmaval.net/docs/15-%20Proveedores%20de%20productos%20SATI%20para%20farmacias.pdf",
    file_sati_16: "https://www.farmaval.net/docs/16-%20Modelo%20solicitud%20ejercicio%20derechos%20del%20interesado.pdf",
    file_sati_17: "https://www.farmaval.net/docs/17-Consentimiento%20cesi%C3%B3n%20imagenes%20y%20videos%20pacientes%20SATI%20.pdf",
    file_sati_18: "https://www.farmaval.net/docs/18-Instrucciones%20solicitudes%20del%20intereado%20en%20la%20Farmacia.pdf",
    file_sati_19: "https://www.farmaval.net/docs/19-Informe%20del%20paciente.pdf",
    file_sati_20: "https://www.farmaval.net/docs/20-%20Informe%20de%20derivaci%C3%B3n%20b%C3%A1sico.pdf",
    file_sati_21: "https://www.farmaval.net/docs/21-%20Informe%20de%20derivaci%C3%B3n%20por%20flujo.pdf",
    file_sati_22: "https://www.farmaval.net/docs/22-%20Infografia%20asma%20i%20colagen.pdf",
    file_sati_23: "https://www.farmaval.net/docs/23-%20Taula%20de%20fluxos%20%C3%B2ptims%20per%20dispositiu.pdf",
    file_sati_24: "https://www.farmaval.net/docs/24-%20Elecci%C3%B3%20inhalador%20principal.pdf",
    file_sati_25: "https://www.farmaval.net/docs/25-%20Pauta%20InmunoRespir%20(cat).pdf",
    file_sati_26: "https://www.farmaval.net/docs/26-%20Quecetina.pdf",
    file_sati_27: "https://www.farmaval.net/docs/27-%20Mapa%20mental%203%20acciones%20inhaladores.pdf",
    // Calendario
    calendar_dates: "Cites",
    calendar_follow: "Seguimient",
    calendar_cepoc: "Candidats CEPOC",
    cepoc_filter_name: "Nom del pacient",
    cepoc_filter_date_from: "Des de",
    cepoc_filter_date_to: "Fins a",
    cepoc_filter_btn: "Filtrar",
    cepoc_clear_btn: "Netejar",
    cepoc_col_name: "Nom",
    cepoc_col_phone: "Tel\xe8fon",
    cepoc_col_date: "Data",
    cepoc_no_results: "No hi ha candidats registrats.",
    cepoc_col_actions: "Accions",
    cepoc_btn_delete: "Eliminar",
    cepoc_confirm_delete: "Esteu segur d'eliminar aquest candidat?",
    day_1: "Dl",
    day_2: "Dm",
    day_3: "Dm",
    day_4: "Dj",
    day_5: "Dv",
    day_6: "Ds",
    day_7: "Dg",
    calendar_months: "Gener,Febrer,Mar\xe7,Abril,Maig,Juny,Juliol,Agost,Setembre,Octubre,Novembre,Desembre",
    date_btn_add: "Afegir cita",
    date_btn_update: "Actualitzar",
    date_btn_delete: "Eliminar",
    date_confirm_delete: "Escrigui <b>eliminar</b> i premi 'Eliminar':",
    date_confirm_delete_text: "eliminar",
    date_no_shift: "No n'hi ha",
    date_popup_title: "Programar cita",
    date_lbl_patient: "Pacient",
    date_lbl_staff: "Persona que agenda el servei",
    date_lbl_service: "Servei",
    date_lbl_date: "Data",
    date_lbl_time: "Horari",
    date_lbl_phone: "Tel\xe8fon",
    date_lbl_comment: "Comentari",
    date_btn_cancel: "Cancel\xb7lar",
    // General
    result_ok: "Operaci\xf3 realitzada",
    error_empty_fields: "Dades incorrectes",
    error_operation: "Error a l'operaci\xf3",
    error_params: "100",
    error_query: "101",
    btn_new: "Nou",
    btn_add: "Afegir",
    btn_update: "Actualitzar",
    btn_delete: "Eliminar",
    // Pending
    pending_info: "Hi ha documentaci\xf3 que ha de ser revisada y signada abans d\u2019iniciar el servei i tenir acc\xe9s a totes les funcions de l\u2019aplicaci\xf3.<br><br>Si us plau, ompli tots els camps dels seg\xfcents formularis i revisi i signi els documents:",
    pending_data: "Documents per revisar i signar",
    pending_agreement_service_form: "Dades implantaci\xf3",
    pending_agreement_sepa_form: "Dades SEPA",
    pending_agreement_service: "Contracte d\u2019 implantaci\xf3",
    pending_agreement_service_info: "Termes i condicions del servei.",
    pending_agreement_sepa: "Ordre de domiciliaci\xf3 SEPA",
    pending_agreement_sepa_info: "Document per a qu\xe8 el seu banc accepti els rebuts emesos per Farmaval.",
    pending_type_admin: "Administrador",
    pending_type_owner: "Titular",
    pending_lbl_pharm_name: "Nom de la farm\xe0cia",
    pending_lbl_address: "Adre\xe7a",
    pending_lbl_city: "Municipi",
    pending_lbl_state: "Comunitat aut\xf2noma",
    pending_lbl_nif: "CIF o NIF d\u2019empresa",
    pending_lbl_signer_type: "En qualitat de:\xa0",
    pending_lbl_signer_dni: "DNI",
    pending_lbl_signer_name: "Nom del signant",
    pending_lbl_debtor_name: "Nom del deutor",
    pending_lbl_debtor_city: "Poblaci\xf3",
    pending_lbl_debtor_state: "Prov\xedncia",
    pending_lbl_debtor_country: "Pa\xeds",
    pending_lbl_debtor_swift: "Swift BIC",
    pending_lbl_debtor_iban: "N\xfamero de compte-IBAN",
    btn_pending_service: "Revisar i signar documents",
    btn_pending_sepa: "Revisar i signar ordre",
    pending_months: "de Gener,de Febrer,de Mar\xe7,d'Abril,de Maig,de Juny,de Juliol,d'Agost,de Setembre,d'Octubre,de Novembre,de Desembre",
    pending_upload: "Enviar documentaci\xf3",
    pending_again: "Tornar a signar",
    checking_data: "Documents en revisi\xf3",
    checking_msg: "S'est\xe0 revisant la documentaci\xf3.<br><br>Tan aviat com estiguin confirmades les dades, se us avisar\xe0 per comen\xe7ar amb la formaci\xf3  de l'equip.<br><br>Gr\xe0cies.",
    // Profile
    settings_title_info: "Informaci\xf3",
    settings_title_admin: "Titular",
    settings_title_pharm: "Dades",
    settings_title_staff: "Equip",
    settings_title_drugs: "Productes",
    settings_title_probiotics: "Probi\xf2tics",
    settings_title_calendar: "Dies de servei",
    settings_title_syncro: "Sincronitzaci\xf3",
    // Probióticos de farmacia — Etapa 05
    profile_probiotics_cn: "Codi Nacional",
    profile_probiotics_pvp: "PVP (\u20AC)",
    profile_probiotics_name: "Nom",
    profile_probiotics_lab: "Laboratori",
    profile_probiotics_strains: "Soques",
    profile_probiotics_format: "Presentaci\xf3",
    profile_probiotics_actions: "Accions",
    profile_probiotics_in_matrix: "A la guia",
    profile_probiotics_in_matrix_yes: "\u2713 S\xed",
    profile_probiotics_not_in_matrix: "\u26A0 No",
    profile_probiotics_lookup: "Cercar",
    profile_probiotics_add: "Afegir probi\xf2tic",
    profile_probiotics_warning: "Probi\xf2tic no trobat a la guia. S'ha notificat a l'equip Curasui.",
    profile_probiotics_found: "\u2713 Trobat a la guia \u2014 dades carregades autom\xe0ticament",
    profile_probiotics_not_found_manual: "\u26A0 No trobat a la guia \u2014 completa les dades m\xednimes per notificar a l'equip",
    profile_probiotics_saved: "Probi\xf2tic afegit correctament.",
    profile_probiotics_saving: "Desant\u2026",
    profile_probiotics_deleting: "Eliminant\u2026",
    btn_activate: "Activar",
    btn_deactivate: "Desactivar",
    // Personal
    staff_lbl_name: "Nom",
    staff_lbl_title: "Categoria",
    staff_lbl_code: "N\xba colegiat",
    staff_lbl_date: "Data",
    staff_lbl_comment: "Comentari",
    staff_lbl_active: "Estat",
    staff_lbl_sati: "Lider/Responsable",
    staff_title_0: "Auxiliar",
    staff_title_1: "T\xe8cnic",
    staff_title_2: "Farmac\xe8utic",
    staff_title_3: "Titular",
    staff_title_4: "Altre",
    staff_active_0: "Inactiu",
    staff_active_1: "Actiu",
    staff_sati_0: "Responsable",
    staff_sati_1: "Lider",
    staff_confirm_delete: "Escrigui <b>eliminar</b> i premi 'Eliminar':",
    staff_confirm_delete_text: "eliminar",
    // Index config days
    day_lbl_name: "Dia",
    day_lbl_from: "Des de",
    day_lbl_to: "Fins",
    day_name_0: "Dilluns",
    day_name_1: "Dimarts",
    day_name_2: "Dimecres",
    day_name_3: "Dijous",
    day_name_4: "Divendres",
    day_name_5: "Dissabte",
    day_name_6: "Diumenge",
    day_confirm_delete: "Escrigui <b>eliminar</b> i premi 'Eliminar':",
    day_confirm_delete_text: "eliminar",
    // productos
    prod_lbl_name: "Nom (castell\xe0)",
    prod_lbl_info: "Informaci\xf3 (castell\xe0)",
    prod_lbl_name_ca: "Nom (catal\xe0)",
    prod_lbl_info_ca: "Informaci\xf3 (catal\xe0)",
    prod_lbl_price: "Preu",
    prod_lbl_service: "Servei",
    prod_lbl_creator: "Creador",
    prod_lbl_state: "Estat",
    prod_state_0: "Inactiu",
    prod_state_1: "Actiu",
    prod_confirm_delete: "Escrigui <b>eliminar</b> i premi 'Eliminar':",
    prod_confirm_delete_text: "eliminar",
    pp_confirm_delete: "Voleu eliminar aquest probi\xf2tic de la vostra llista?",
    // farmacia
    pharm_lbl_name: "Nom",
    pharm_lbl_business: "Ra\xf3 social",
    pharm_lbl_nif: "CIF",
    pharm_lbl_address: "Direcci\xf3",
    pharm_lbl_city: "Ciutat",
    pharm_lbl_state: "Provincia",
    pharm_lbl_postal: "Codi postal",
    pharm_lbl_email: "Email",
    pharm_lbl_phone: "Tel\xe8fon fix",
    pharm_lbl_mobile: "Tel\xe8fon m\xf2nil",
    pharm_lbl_web: "Web",
    pharm_lbl_admin_name: "Nom",
    pharm_lbl_admin_code: "N\xba col\xb7legiat",
    pharm_lbl_admin_email: "Email",
    pharm_lbl_admin_signature: "Signatura",
    pharm_lbl_admin_password: "Contrasenya",
    pharm_lbl_user: "Usuari",
    pharm_lbl_password: "Contrasenya",
    pharm_password_empty: "Deixar buit per a no canviar",
    pharm_lbl_language: "Idioma",
    pharm_lbl_password: "Contrasenya",
    pharm_lbl_logo: "Logo pels informes (aspecte 3/1)",
    pharm_lbl_schedule: "Horari",
    pharm_lbl_schedule_0: "Ininterromput",
    pharm_lbl_schedule_1: "Partit",
    pharm_lbl_schedule_2: "24 hores",
    day_btn_add: "Afegir horari",
    day_btn_delete: "Eliminar",
    question_remove_day: "Eliminar horari de servei: ",
    error_loading_days: "Problema en carregar dies disponibles.",
    error_removing_day: "No s\u2019ha pogut eliminar l\u2019horari.",
    error_adding_day: "No s\u2019ha pogut afegir l\u2019horari.",
    // PDF viewer
    pdf_close: "Tancar informe",
    // Popup
    popup_ok: "Acceptar",
    popup_close: "Tancar",
    popup_cancel: "Cancel\xb7lar",
    // Index
    new_link_more: "M\xe9s informaci\xf3",
    // Index config products
    products_lbl_list: "Productes disponibles.",
    products_lbl_service: "Servei.",
    error_loading_products: "Problema en carregar els productes.",
    product_lbl_name: "Producte",
    product_lbl_info: "Informaci\xf3",
    product_lbl_cost: "Preu",
    product_lbl_cn: "CN",
    product_btn_add: "Afegir",
    product_btn_edit: "Modificar",
    product_btn_delete: "Esborrar",
    product_msg_empty: "Cal emplenar-ne tots els camps.",
    product_msg_cost: "El preu no \xe9s un valor correcte.",
    product_msg_error: "S\u2019ha produ\xeft un problema en realitzar l\u2019operaci\xf3.",
    product_question_edit: "Vol modificar el producte seleccionat?",
    product_question_delete: "Vol eliminar el producte seleccionat?",
    // Index calendar
    calendar_days: "Dl,Dm,Dm,Dj,Dv,Ds,Dg",
    calendar_months: "Gener,Febrer,Mar\xe7,Abril,Maig,Juny,Juliol,Agost,Setembre,Octubre,Novembre,Desembre",
    calendar_times: "Horaris: ",
    calendar_no_times: "No n\u2019hi ha",
    calendar_date_title: "Cites del dia ",
    calendar_no_dates: "No hi ha cites",
    btn_cancel_date: "cancel\xb7lar",
    btn_edit_date: "editar",
    lbl_date_phones: "Tels:",
    new_date_text: "Afegir cita el dia:",
    new_date_lbl_patient: "Pacient",
    new_date_lbl_staff: "T\xe8cnic/a",
    new_date_lbl_service: "Servei",
    new_date_lbl_date: "Data",
    new_date_lbl_time: "Horari",
    new_date_lbl_phone: "Tel\xe8fon",
    new_date_lbl_comment: "Comentari",
    new_date_error_empty: "Falten dades per emplenar",
    new_date_error_server: "Error en afegir la cita",
    new_date_confirm_remove: "Eliminar cita de ",
    error_loading_date: "Error carregant dades",
    // News y Mensajes
    error_loading_news: "No s\u2019ha pogut carregar les not\xedcies.",
    lbl_loading_news: "Carregant not\xedcies...",
    loading_reports: "Carregant dades...",
    title_news: "Not\xedcies",
    //title_chat:"Contacte",
    // Reports
    reports_group_respiratory: "Respiratoris",
    reports_group_digestive: "Probi\xf2tics",
    reports_list: "Serveis",
    reports_staff: "Equip",
    reports_stats: "Informes SATI",
    reports_stats_iretia: "Informes IRETIA",
    reports_dosing: "Intervencions de Pauta",
    filter_dosing_drug: "Medicament",
    filter_dosing_patient: "Pacient",
    filter_dosing_state: "Estat",
    filter_dosing_state_all: "Totes",
    filter_dosing_state_active: "Actives",
    filter_dosing_state_deleted: "Eliminades",
    filter_dosing_correction: "Resultat",
    filter_dosing_correction_all: "Totes",
    filter_dosing_correction_correct: "Correctes",
    filter_dosing_correction_adjusted: "Ajustades",
    lbl_dosing_caption: "Intervencions de pauta",
    lbl_dosing_drug: "Medicament",
    lbl_dosing_patient: "Pacient",
    lbl_dosing_staff: "T\xe8cnic",
    lbl_dosing_doctor_doses: "Pauta m\xe8dica",
    lbl_dosing_patient_doses: "Pauta pacient",
    lbl_dosing_status: "Estat",
    dosing_delete_popup_title: "Donar de baixa intervenci\xf3 de pauta",
    dosing_delete_reason_label: "Motiu de la baixa",
    lbl_dosing_monthly_margin: "Marge mensual (\u20AC)",
    lbl_dosing_annual_margin: "Marge anual (\u20AC)",
    lbl_dosing_accepts: "Accepta correcci\xf3",
    dosing_col_actions: "Accions",
    dosing_status_over: "Sobre dosificat",
    dosing_status_under: "Sub dosificat",
    dosing_status_correct: "Correcte",
    dosing_accepts_yes: "S\xed",
    dosing_accepts_no: "No",
    dosing_confirm_delete: "Esteu segur d'eliminar aquesta intervenci\xf3 de pauta?",
    lbl_report_staff_name: "Nom",
    lbl_report_staff_SATI: "SATI",
    lbl_report_staff_IRETIA: "IRETIA",
    lbl_report_staff_CEPOC: "CEPOC",
    lbl_report_staff_dates_count: "Cites taulell",
    lbl_report_staff_dates_service_count: "Cites servei",
    lbl_report_staff_last_service: "\xdaltim servei",
    lbl_report_staff_last_date: "\xdaltima cita",
    lbl_report_staff_state: "Estat",
    lbl_report_staff_state_active: "Actiu",
    lbl_report_staff_state_noactive: "Inactiu",
    lbl_report_type: "Servei",
    lbl_report_date: "Data",
    lbl_report_name: "Nom",
    lbl_report_staff: "T\xe8cnic/a",
    lbl_report_sales: "Vendes",
    lbl_report_main: "Inhalador",
    lbl_report_visit: "Visita In.",
    lbl_report_visit_real: "Visita",
    filter_service: "Servei",
    filter_from: "Des de",
    filter_to: "Fins",
    filter_patient: "Cognoms pacient",
    filter_btn: "Mostrar",
    filter_type_all: "Tots",
    filter_type_sati: "SATI",
    filter_type_iretia: "IRETIA",
    filter_type_cepoc: "CEPOC",
    filter_type_deleted: "Eliminats",
    report_popup_title: "Editar servicio",
    report_lbl_comment: "Comentario",
    report_lbl_sales: "Ventas",
    report_lbl_product_type: "Producto",
    report_lbl_product_name: "Nombre",
    report_lbl_product_cost: "Coste",
    report_lbl_product_quantiy: "Cantidad",
    report_btn_update: "Actualitzar",
    report_btn_recover: "Recuperar",
    report_btn_delete: "Eliminar",
    report_btn_remove: "Eliminar definitivament",
    report_btn_cancel: "Cancel\xb7lar",
    report_btn_view_patient: "Informe del pacient",
    report_btn_view_doctor: "Informe derivaci\xf3 metge",
    report_confirm_delete: "Introdu\xefu <b>eliminar</b> i feu clic a 'Eliminar':",
    report_confirm_delete_text: "eliminar",
    report_confirm_remove: "Introdu\xefu <b>eliminar definitivament</b> i feu clic a 'Eliminar definitivament':",
    report_confirm_remove_text: "eliminar definitivament",
    report_sale_remove: "Treure",
    report_sale_add: "Afegir",
    // Pacientes
    patients_list: "Consulta",
    patients_followup: "Seguiment",
    filter_patient_name: "Cognoms del pacient",
    filter_patient_order: "Ordenar por",
    filter_patient_order_name: "Cognoms",
    filter_patient_order_next_visit: "Propera visita",
    col_patient_name: "Pacient",
    col_patient_com_mode: "Comunicacions",
    col_patient_contact: "Contacte",
    col_patient_lng: "Idioma",
    col_patient_visits: "Visites",
    col_patient_next_visit: "Propera visita",
    patient_contact_email: "Email",
    patient_contact_call: "Trucada",
    patient_contact_sms: "SMS",
    patient_tab_basic: "Dades b\xe0siques",
    patient_tab_com: "Comunicacions",
    patient_tab_clinic: "Metge",
    patient_popup_title: "Editar pacient",
    patient_lbl_dni: "DNI",
    patient_lbl_name: "Nom",
    patient_lbl_surname_1: "Primer cognom",
    patient_lbl_surname_2: "Segon cognom",
    patient_lbl_date: "Data de naixement",
    patient_lbl_sex: "Sexe",
    patient_lbl_smoker: "Fumador",
    patient_lbl_town: "Poblaci\xf3",
    patient_lbl_postal: "Codi postal",
    patient_lbl_com_mode: "Comunicacions",
    patient_lbl_phone: "Tel\xe8fon (trucada)",
    patient_lbl_mobile: "Tel\xe8fon (SMS)",
    patient_lbl_email: "Email",
    patient_lbl_language: "Idioma",
    patient_lbl_doctor_genere: "Dr./Dra.",
    patient_lbl_doctor: "Metge de cap\xe7alera",
    patient_lbl_center: "Centre m\xe8dic",
    patient_lbl_comment: "Possibles substitucions a la derivaci\xf3 per flux",
    patient_value_yes: "S\xed",
    patient_value_no: "No",
    patient_value_man: "Mascul\xed",
    patient_value_woman: "Femen\xed",
    patient_value_dr: "Doctor",
    patient_value_dra: "Doctora",
    patient_btn_delete: "Eliminar pacient",
    patient_btn_new: "Nou pacient",
    patient_btn_add: "Registrar pacient",
    patient_btn_update: "Actualitzar dades",
    patient_btn_cancel: "Cancel\xb7lar",
    patient_btn_history: "Veure historial",
    patient_confirm_delete: "Atenci\xf3! Utilitzeu aquesta opci\xf3 nom\xe9s si sou un pacient de proves. Per confirmar, escriviu <b>eliminar</b> i premeu 'Eliminar':",
    patient_confirm_delete_text: "eliminar",
    // Sincronización
    syncro_lbl_data: "Dades emmagatzemades localment",
    syncro_lbl_value: "Total",
    syncro_data_staff: "Equip de la farm\xe0cia",
    syncro_data_drugs: "Medicaments",
    syncro_data_days: "Dies de servei",
    syncro_data_products: "Productes",
    syncro_data_services: "Serveis",
    syncro_lbl_date: "\xdaltima actualitzaci\xf3",
    syncro_lbl_services: "Llista de serveis per a sincronitzar",
    syncro_data_services_none: "Cap servei",
    btn_syncro_now: "Sincronitzar ara",
    // stats
    btn_stats_print: "Imprimir",
    stats_title_report: "Servei d'Acompanyament a Ter\xe0pia Inhalada",
    stats_from: "Informes des de ",
    stats_to: " fins a ",
    stats_financial_title: "Dades financeres econ\xf2miques",
    stats_visit_all: "Totes les visites",
    stats_visit_1: "Primera visita",
    stats_visit_2: "Segona visita",
    stats_visit_3: "Tercera visita i posteriors",
    stats_title_services: "Serveis",
    stats_title_time: "Duraada",
    stats_title_time_per: "Durada per servei",
    stats_title_sales: "Vendes",
    stats_title_sales_per: "Vendes per servei",
    stats_prescription: "Abordaments",
    stats_title_prescription: "Serveis amb almenys un abordament",
    stats_title_prescription_per: "% de serveis",
    stats_sales: "Productes venuts",
    stats_title_quantity: "Quantitat",
    stats_title_total: "Total",
    stats_all_staff: "Total",
    stats_farmaval: "Mitjana Farmaval",
    chart_services: "Serveis totals",
    chart_time_avg: "Temps mitj\xe0 per servei",
    chart_prescriptions: "Abordaments (vendes)",
    chart_prescriptions_service: "Abordaments per servei",
    chart_media: "Farmaval: Mitjana",
    chart_best: "Farmaval: Millors",
    chart_pharm: "Farm\xe0cia",
    chart_visits: "Totes les visites",
    chart_visit_1: "Primera visita",
    chart_visit_2: "Segona visita",
    chart_visit_3: "Tercera visita i posteriors",
    stats_col_visits: "Visites",
    stats_col_staff: "Equip",
    stats_col_product: "Producte",
    stats_col_indicator: "Indicador",
    stats_col_error: "Error",
    stats_dosing_title: "Intervencions de pauta",
    stats_dosing_accepted_subtitle: "Pautes acceptades pels pacients",
    stats_dosing_missing_subtitle: "Pautes no acceptades pels pacients",
    stats_dosing_item: "Item",
    stats_dosing_value: "Valor",
    stats_dosing_corrections: "Nombre d'intervencions de pauta",
    stats_dosing_monthly_revenue: "Facturaci\xf3 total mensual",
    stats_dosing_monthly_margin: "Marge total mensual",
    stats_dosing_annual_revenue: "Facturaci\xf3 anualitzada",
    stats_dosing_annual_margin: "Marge anualitzat",
    stats_dosing_top_drugs: "Medicaments principals",
    stats_dosing_drug_name: "Medicament",
    stats_dosing_drug_format: "Format",
    stats_dosing_drug_monthly_revenue: "Facturaci\xf3 mensual",
    stats_dosing_drug_monthly_margin: "Marge mensual",
    stats_dosing_drug_annual_revenue: "Facturaci\xf3 anualitzada",
    stats_dosing_drug_annual_margin: "Marge anualitzat",
    stats_medical_title: "Dades assistencials",
    stats_technique: "Millora a la t\xe8cnica inhalada",
    stats_asma: "Dades d'asma",
    stats_asma_kids: "Dades d'asma infantil",
    stats_epoc: "Dades de MPOC",
    stats_aco: "Dades d'ACO",
    stats_medical_services: "Nombre de serveis",
    stats_points_asma: "Puntuaci\xf3 mitjana<br><small>5 mal control -> 25 bon control</small>",
    stats_points_asma_kids: "Puntuaci\xf3 mitjana<br><small>0 mal control -> 27 bon control</small>",
    stats_points_epoc: "Puntuaci\xf3 mitjana<br><small>40 impacte molt alt -> 0 impacte baix</small>",
    stats_points_aco: "Puntuaci\xf3 mitjana<br><small>40 impacte molt alt -> 0 impacte baix</small>",
    stats_control_perfect: "Control total",
    stats_control_good: "Control bo",
    stats_control_bad: "No controlat",
    stats_control_ok: "Controlat",
    stats_control_ko: "No controlat",
    stats_impact_low: "Impacte baix",
    stats_impact_middle: "Impacte mitj\xe0",
    stats_impact_high: "Impacte alt",
    stats_impact_higher: "Impacte molt alt",
    stats_errors: "Errors m\xe9s comuns",
    stats_medical_visits: "Visites",
    stats_medical_visit_1: "Visita 1a",
    stats_medical_visit_2: "Visita 2a",
    stats_medical_visit_3: "Visita >2a",
    stats_medical_improvment: "Millora",
    stats_medical_quantity: "Quantitat",
    stats_medical_info: "Els c\xe0lculs de control de malaltia es realitzen nom\xe9s amb les dades de les tres primeres visites. Els resultats de les seg\xfcents visites de seguiment no es tenen en compte.",
    stats_technique_pharm: "Mitja d'errors en t\xe8cnica",
    stats_technique_media: "Mitja Farmaval",
    stats_help_chart_services: "Compara el n\xba de serveis SATI de la farm\xe0cia amb la mitjana i els millors de Farmaval, per tipus de visita.",
    stats_help_chart_times: "Temps mitj\xe0 per servei en minuts (m\xedn. 10 min per servei). Menor temps = millor a la columna Millors.",
    stats_help_dosing_accepted: "Impacte econ\xf2mic de correccions de pauta acceptades (infra-dosificaci\xf3): total mensual i projecci\xf3 anual (\xd712).",
    stats_help_dosing_missing: "Mateix c\xe0lcul per a pautes no acceptades: oportunitat econ\xf2mica no capturada.",
    stats_help_financial_visit: "Per empleat: n\xba serveis, durada total i mitjana, vendes totals i per servei. Fila Total = farm\xe0cia. Filtrat pel tipus de visita del t\xedtol.",
    stats_help_chart_prescriptions: "Compara vendes totals (\u20AC) associades a serveis SATI vs mitjana i millors Farmaval, per visita.",
    stats_help_chart_prescriptions_service: "Compara vendes mitjanes per servei (\u20AC) vs mitjana i millors Farmaval, per visita.",
    stats_help_prescriptions: "Serveis amb almenys una venda registrada i % sobre el total de serveis del per\xedode (totes les visites).",
    stats_help_sales: "Productes venuts en serveis SATI: unitats i import (\u20AC), ordenats per total.",
    stats_help_technique: "Mitja d'errors de t\xe8cnica per visita i % de millora en baixar errors entre visites. Compara farm\xe0cia vs mitjana Farmaval.",
    stats_help_asma: "Asma adulta (\u226512): n\xba serveis, puntuaci\xf3 mitjana ACT i % control total (25), bo (20\u201324) i no controlat (5\u201319) per visita.",
    stats_help_asma_kids: "Asma infantil (<12): n\xba serveis, puntuaci\xf3 mitjana C-ACT i % controlat (\u226520) / no controlat (0\u201319) per visita.",
    stats_help_epoc: "MPOC: n\xba serveis, puntuaci\xf3 mitjana CAT i % per impacte (baix 0\u201310, mitj\xe0 11\u201320, alt 21\u201330, molt alt 31\u201340).",
    stats_help_aco: "ACO: mateixa lectura que MPOC amb puntuaci\xf3 CAT i trams d'impacte.",
    stats_help_errors: "Els 8 errors de t\xe8cnica inhalat\xf2ria m\xe9s freq\xfcents en el per\xedode (nom\xe9s serveis amb errors detectats).",
    // stats IRETIA
    stats_pharm: "Farm\xe0cia",
    stats_farmaval: "Farmaval",
    stats_iretia_title_report: "Servei d'intervenci\xf3 r\xe0pida en ter\xe0pia inhalada aguda",
    stats_iretia_title_1: "Dades generals",
    stats_iretia_title_2: "Perfil pacients",
    stats_iretia_title_3: "Diagn\xf2stics",
    stats_iretia_title_4: "Inahaladors m\xe9s dispensats",
    stats_iretia_title_5: "Errors m\xe9s comuns",
    stats_iretia_title_6: "Prestaci\xf3 de servei per membre de l'equip",
    stats_iretia_col_1: "La meva farm\xe0cia",
    stats_iretia_col_2: "Mitja farm\xe0cies Farmaval",
    stats_iretia_col_3: "Farm\xe0cia m\xe9s activa",
    stats_iretia_1: "Nombre serveis IRETIA prestats",
    stats_iretia_2: "Temps mitj\xe0 invertit per servei (minuts)",
    stats_iretia_3: "Total vendes associades servei",
    stats_iretia_4: "Mitja de vendes per servei",
    stats_iretia_5: "Serveis amb vendes associades",
    stats_iretia_6: "Mitja d'errors",
    stats_iretia_7: "Serveis amb almenys 1 error en la t\xe8cnica",
    stats_iretia_8: "Valoraci\xf3 molt \xfatil del servei",
    stats_iretia_9: "Valoraci\xf3 comprom\xeds molt alt de la farm\xe0cia",
    stats_iretia_8_3: "No ho sap",
    stats_iretia_8_0: "Bronquitis aguda",
    stats_iretia_8_7: "Bronquitis asm\xe0tica",
    stats_iretia_8_1: "Pneum\xf2nia",
    stats_iretia_8_2: "Covid o Post Covid",
    stats_iretia_8_5: "Cardiovascular",
    stats_iretia_8_9: "Refredat com\xfa",
    stats_iretia_8_10: "Grip",
    stats_iretia_8_6: "Un altre",
    stats_iretia_9_1: "Dones",
    stats_iretia_9_2: "Mitja edat",
    stats_iretia_9_3: "Fumadors",
    stats_iretia_9_4: "Ex fumador",
    stats_iretia_9_5: "Fumador passiu",
    stats_iretia_9_6: "No fumador",
    stats_iretia_first: "1r",
    stats_iretia_second: "2n",
    stats_iretia_third: "3r",
    stats_iretia_team_1: "Serveis",
    stats_iretia_team_2: "Temps mitj\xe0",
    stats_iretia_team_3: "Vendes",
    stats_iretia_team_4: "Mitja de vendes",
    stats_iretia_team_5: "Serveis amb vendes",
    stats_iretia_products: "Productos venuts",
    stats_iretia_product_qty: "Quantitat",
    stats_iretia_product_total: "Total",
    // Settings
    settings_info_drugs: "Gesti\xf3 de productes recomanats pels serveis.",
    settings_info_calendar: "Selecci\xf3 de dies h\xe0bils per defecte per a la realitzaci\xf3 de serveis.",
    settings_info_syncro: "Informaci\xf3 sobre les dades desades localment.",
    settings_info_pharm: "Opcions generals relatives a l\u2019aplicaci\xf3 i a la farm\xe0cia.",
    settings_lbl_signature: "Signatura del/de la titular",
    settings_lbl_version: "Versi\xf3 de l\u2019aplicaci\xf3",
    settings_lbl_pharm: "Farm\xe0cia",
    settings_lbl_disabled: "En desenvolupament",
    settings_lbl_noactive: "No activat",
    error_loading_pharm: "Problema mentre s\u2019hi carregaven les dades de la farm\xe0cia",
    no_signature_msg: "El sistema no disposa d\u2019una signatura del titular de la farm\xe0cia. \xc9s necess\xe0ria per signar els informes.<br><br/>Es pot establir des de la secci\xf3 de configuraci\xf3.",
    no_passwords_msg: "Falta contrasenya d\u2019acc\xe9s. El sistema no \xe9s segur. Si us plau, estableixi la contrasenya des de la secci\xf3 de configuraci\xf3.",
    no_signature_passwords_msg: "El sistema no disposa d\u2019una signatura del titular de la farm\xe0cia (necess\xe0ria per signar els informes) ni tampoc de contrasenya d\u2019acc\xe8s.<br><br/>Es poden establir des de la secci\xf3 de configuraci\xf3.",
    settings_btn_new_signature: "Nova signatura",
    signature_pharm_title: "Signatura del titular de la farm\xe0cia",
    settings_password_public_lbl: "Contrasenya d'access",
    settings_password_public_info: "Est\xe0 associada a l\u2019usuari/l\u2019adre\xe7a de correu electr\xf2nic de la farm\xe0cia i permet l'acce\xe9s a l'aplicatiu i realitzar serveis.",
    warning_nopassword: "Atenci\xf3! No n\u2019hi ha, de contrasenya.",
    btn_new_password: "Establir-ne contrasenya",
    btn_change_password: "Canviar-ne contrasenya",
    new_password_must_1: "M\xe9s de 7 car\xe0cters.",
    new_password_must_2: "Incloure lletres.",
    new_password_must_3: "Incloure n\xfameros.",
    new_password_must_4: "Incloure s\xedmbols.",
    new_password_must_5: "Confirmar-ne la contrasenya.",
    new_password_value: "Nova contrasenya",
    new_password_repeat: "Confirmar-ne la contrasenya.",
    new_password_public_title: "Canviar la contrasenya dels t\xe8cnics.",
    new_password_error: "Error en intentar assignar la contrasenya. Si us plau, intenti-ho novament.",
    new_password_notallowed: "Un usuari t\xe8cnic no pot canviar les contrasenyes. Si us plau, inici\xef sessi\xf3 com a administrador.",
    // Service
    signature_title_modal: "Recollida de dades per la prestaci\xf3 del servei SATI",
    signature_text_check1: "AUTORITZO l\u2019\xfas de les meves dades per a la prestaci\xf3 del Servei en Acompanyament en Ter\xe0pia Inhalada.",
    signature_text_check2: "AUTORITZO l\u2019\xfas de les meves dades per a la realitzaci\xf3 de comunicacions telem\xe0tiques (SMS, missatges, adre\xe7a de correu electr\xf2nic, etc.)",
    signature_text_check3: "AUTORITZO l\u2019\xfas de les meves dades per a la realitzaci\xf3 d\u2019estudis d\u2019investigaci\xf3 assistencial.",
    signature_text_check4: "AUTORITZO a la farm\xe0cia a compartir amb el metge que em tracta la informaci\xf3 sobre el tractament inhalat que prenc per tal de millorar els meus resultats terap\xe8utics.",
    signature_image_title_modal: "Consentiment expl\xedcit per a la publicaci\xf3 i el tractament d'imatges general",
    signature_image_radio1: "AUTORITZO l\u2019\xfas de les imatges.",
    signature_image_radio2: "NO AUTORITZO l\u2019\xfas de les imatges",
    signature_label_patient: "En ser menor, escrigui el nom de la persona responsable.",
    signature_btn_clear: "Comen\xe7ar de nou",
    signature_btn_ok: "Acceptar",
    signature_btn_cancel: "Cancel\xb7lar",
    signature_error: "No ha estat possible emmagatzemar la nova signatura. Si us plau, intenti-ho novament.",
    service_error_unknown: "El servei no existeix",
    service_error_loading: "Error en carregar els serveis",
    service_error_patient: "Error en carregar el formulari del pacient",
    service_error_staff: "Error en carregar les dades dels responsables",
    service_error_service: "Error en carregar les dades del servei",
    service_btn_cancel: "Cancel\xb7lar el servei",
    service_btn_prev: "Enrere",
    service_btn_next: "Seg\xfcent",
    tab_start_title: "Inici del servei",
    tab_start_info: "Seleccioni el t\xe8cnic que realitzar\xe0 el servei i empleni la fitxa del pacient. Si el pacient ja est\xe0 registrat, el pot buscar pel DNI o els seus cognoms.",
    tab_start_info_iretia: "Seleccioni el t\xe8cnic que realitzar\xe0 el servei i empleni les dades del pacient. En cas de cessi\xf3 de drets d'imatge, empleni DNI, nom i cognoms.",
    tab_start_staff_info: "T\xe8cnic del servei",
    lbl_question_cancel: "Est\xe0 segur/a que vol cancel\xb7lar-ne el servei? No s\u2019hi guardar\xe0 cap dada.",
    lbl_question_new: "Escrigui el nom del nou t\xe8cnic:",
    lbl_question_update: " Escrigui el nou nom del t\xe8cnic:",
    lbl_question_delete: "Est\xe0 segur/a que hi vol eliminar el t\xe8cnic seleccionat?",
    btn_staff_delete: "Eliminar seleccionat",
    btn_staff_update: "Modificar",
    btn_staff_new: "Nou",
    tab_start_patient_info: "Fitxa del pacient",
    lbl_patient_search: "Cercant pacient...",
    lbl_patient_new: "Nou pacient",
    lbl_patient_error: "Error en el servidor",
    lbl_patient_dni: "DNI",
    lbl_patient_name: "Nom",
    lbl_patient_surname_1: "Primer cognom",
    lbl_patient_surname_2: "Segon cognom",
    lbl_patient_date: "Data de naixement",
    lbl_patient_age: "Edat",
    lbl_patient_sex: "Sexe",
    lbl_patient_smoke: "Fumador",
    lbl_patient_extra: "Dades si el pacient cedeix els drets d'imatge",
    options_patient_sex: "Dona/1,Home/0",
    options_patient_smoke: "No/0,S\xed/1",
    lbl_patient_studies: "Estudis",
    lbl_patient_tsi: "TSI",
    options_patient_studies: "Sense estudis/0,B\xe0sics/1,Batxillerat/2,Grau t\xe8cnic/3,Universitaris/4",
    lbl_patient_town: "Poblaci\xf3",
    lbl_patient_postal: "Codi postal",
    lbl_patient_phone: "Tel\xe8fon fix (trucada)",
    lbl_patient_mobile: "Tel\xe8fon m\xf2bil (SMS)",
    lbl_patient_contact: "Tel\xe8fon m\xf2bil",
    lbl_patient_email: "Correu electr\xf2nic",
    lbl_patient_com_mode: "Comunicacions",
    lbl_patient_lang: "Idioma",
    options_patient_com_mode: "Per correu electr\xf2nic/0,Per trucada/1,Per SMS/2",
    options_patient_lang: "Catal\xe0/ca,Castellano/es",
    lbl_patient_doctor_genere: "Dr./Dra.",
    options_patient_doctor_genere: "Dr./0,Dra./1",
    lbl_patient_doctor: "Metge de cap\xe7alera",
    lbl_patient_center: "Centre m\xe8dic",
    lbl_patient_comment: "Possibles substitucions a la derivaci\xf3 per flux",
    lbl_patient_sign: "Signatura del pacient:",
    section_patient_title: "Dades b\xe0siques del pacient:",
    section_patient_info: "Empleni les dades si \xe9s un nou pacient o actualitzi-les si cal.",
    form_error_staff: "Seleccioni el seu nom com a responsable del servei.",
    form_error_required: "Falten dades per emplenar.",
    form_error_pattern: "El format no \xe9s el correcte.",
    form_error_contact: "Ha d\u2019indicar la dada de contacte.",
    form_error_options: "Hi ha preguntes del q\xfcestionari sense respondre.",
    // 0.7.3
    title_chat: "Contacte",
    info_chat: "Pots enviar-nos un correu directament des d\u2019aqu\xed.",
    placeholder_chat: "Missatge a enviar",
    btn_chat_send: "Enviar",
    email_ok: "Gr\xe0cies, et respondrem al m\xe9s aviat possible.",
    email_error: "No hem pogut enviar el correu, si-us-plau, intenta-ho novament o b\xe9 posa\u2019t en contacte amb nosaltres a trav\xe9s de farmaval.net",
    // 0.7.5
    rep_title_change: "Servei a: ",
    rep_comment: "Comentari",
    rep_btn_patient: "Informe pacient",
    rep_btn_doctor: "Informe m\xe8dic",
    rep_btn_delete: "Eliminar servei",
    rep_btn_remove: "Eliminar definitivament",
    rep_btn_confirm: "Confirmar eliminar",
    rep_btn_save: "Actualitzar",
    rep_btn_restore: "Restaurar",
    rep_sales: "Productes venuts",
    rep_sale_remove: "Eliminar",
    rep_products: "Productes",
    rep_prod_name: "Nom",
    rep_prod_cost: "Preu",
    rep_prod_qty: "Quantitat",
    rep_prod_add: ">>",
    rep_prod_other: "Altre",
    rep_result_error: "Error realitzant operaci\xf3",
    rep_result_notallowed: "\xdanicament el titular pot eliminar registres.",
    service_error_loading_data: "Hi ha hagut un error actualitzant les dades per iniciar el servei.",
    service_error_local_data: "No s'han pogut carregar dades per iniciar el servei. Assegureu-vos que hi ha connexi\xf3 a Internet i torneu a intentar-ho.",
    service_warning_local_data: "\xc9s possible que les dades per iniciar el servei estiguin desactualitzades.",
    service_online: "Conectat",
    service_offline: "Sense conexi\xf3",
    end_reports_question: "Confirmar la finalitzaci\xf3 del servei.",
    end_error_reports: "Problema en generar informes i emmagatzemar-ne el servei.",
    end_error_reports_backup: "Problema en desar el servei. S'emmagatzemar\xe0 de forma local per no perdre les dades.<br><br>Podeu realitzar la sincronitzaci\xf3 amb el servidor des de la secci\xf3 de configuraci\xf3.",
    // Probiomentor — Material divulgatiu i formació
    probio_formation_btn: "Accedir a Probio Experts",
    probio_formation_sub: "Formaci\xf3 especialitzada en probi\xf2tics",
    probio_material_title: "Material Probio Mentor",
    probio_material_subtitle: "Descarrega flyers i posts per a xarxes socials",
    // Missatges de Probio
    probio_loading: "Generant acc\xe9s segur...",
    error_probio_link: "No s'ha pogut generar l'acc\xe9s a Probio. Si us plau, torneu-ho a intentar o contacteu amb suport.",
    error_probio_service: "El servei Probio no est\xe0 actiu per a la vostra farm\xe0cia.",
    error_session: "Error de sessi\xf3. Si us plau, torneu a iniciar sessi\xf3.",
    error_server: "Error de connexi\xf3 amb el servidor. Si us plau, torneu-ho a intentar.",
    // Probiomentor — Servei d'abordatge (Etapa 08)
    probio_step_staff_title: "Qui realitza l'abordatge?",
    probio_step_indication_title: "Quina \xe9s la indicaci\xf3 del pacient?",
    probio_step_probiotics_title: "Probi\xf2tics amb evid\xe8ncia cient\xedfica",
    probio_see_stats: "Veure les meves estad\xedstiques",
    probio_search_placeholder: "Cercar indicaci\xf3...",
    probio_in_stock: "Preferent",
    probio_evidence: "Evid\xe8ncia",
    probio_dosage: "Pauta",
    probio_accepted: "\u2713 Dispensaci\xf3 Acceptada",
    probio_rejected: "\u2717 Dispensaci\xf3 No Acceptada",
    probio_congrats_accepted: "Excel\xb7lent abordatge! El pacient ho ha acceptat.",
    probio_congrats_rejected: "Abordatge registrat. El pacient no ho ha acceptat en aquesta ocasi\xf3.",
    probio_new_advice: "Nou abordatge",
    probio_filter_all: "Totes les categories",
    probio_select_indication: "Seleccioneu una indicaci\xf3...",
    probio_search_btn: "Cercar Probi\xf2tics amb Evid\xe8ncia Cient\xedfica",
    // Probiomentor — Consultes (Etapa 09)
    probio_reports_tab: "Serveis Probiomentor",
    probio_team_tab: "Informe Probiomentor",
    probio_team_subtab_services: "Serveis",
    probio_team_subtab_consultas: "Consultes",
    probio_team_services_title: "Serveis Probiomentor - Equip",
    probio_team_services_help: "Desglossament per membre de l'equip: abordatges, acceptaci\xf3, temps mitj\xe0 i vendes.",
    probio_team_col_total: "Total abordatges",
    probio_team_col_accepted: "Acceptats",
    probio_team_col_rejected: "No acceptats",
    probio_team_col_rate: "% Acceptaci\xf3",
    probio_team_col_time: "Temps mitj\xe0 (min)",
    probio_team_col_sales: "Vendes (\u20AC)",
    probio_team_col_avg_sale: "Mitjana vendes (\u20AC)",
    // Dades generals (comparativa amb la mitjana i el millor de Farmaval)
    probio_services_stats_title: "Dades generals",
    probio_services_stats_help: "Compara els indicadors clau de la teva farm\xe0cia amb la mitjana i el millor valor de Farmaval.",
    probio_services_stats_col_indicator: "Indicador",
    probio_services_stats_col_pharmacy: "La teva farm\xe0cia",
    probio_services_stats_col_average: "Mitjana farm\xe0cies",
    probio_services_stats_col_best: "Millor farm\xe0cia",
    probio_dg_services: "Serveis prestats",
    probio_dg_services_per_day: "Mitjana de serveis per dia",
    probio_dg_services_per_person: "Mitjana de serveis per persona de l'equip",
    probio_dg_avg_time: "Temps mitj\xe0 (min)",
    probio_dg_total_sales: "Total vendes (\u20AC)",
    probio_dg_avg_sale: "Mitjana de vendes per servei (\u20AC)",
    probio_dg_with_sales: "Serveis amb acceptaci\xf3 (%)",
    // Indicacions més freqüents
    probio_indications_title: "Indicacions m\xe9s freq\xfcents",
    probio_indications_help: "Indicacions m\xe9s consultades a la teva farm\xe0cia, amb el seu pes davant la mitjana de Farmaval.",
    probio_indications_col_name: "Indicaci\xf3",
    probio_indications_col_pharmacy: "La teva farm\xe0cia (%)",
    probio_indications_col_average: "Mitjana farm\xe0cies (%)",
    probio_indications_empty: "Sense dades en el per\xedode seleccionat.",
    probio_indications_others: "Altres",
    // Probiòtics més dispensats
    probio_top_title: "Probi\xf2tics m\xe9s dispensats",
    probio_top_help: "Els tres probi\xf2tics m\xe9s recomanats a la teva farm\xe0cia.",
    probio_top_col_rank: "Posici\xf3",
    probio_top_col_pharmacy: "La teva farm\xe0cia",
    // Probiòtics venuts
    probio_products_title: "Probi\xf2tics venuts",
    probio_products_help: "Probi\xf2tics venuts per la teva farm\xe0cia.",
    probio_products_col_product: "Producte",
    probio_products_col_quantity: "Quantitat",
    probio_products_col_total: "Total (\u20AC)",
    probio_products_total_row: "Total",
    probio_products_empty: "Sense vendes registrades en el per\xedode seleccionat.",
    // Baixa lògica de serveis de l'historial Probiomentor
    probio_history_col_actions: "Accions",
    probio_history_deleted_badge: "Donat de baixa",
    probio_history_delete_popup_title: "Donar de baixa servei Probiomentor",
    probio_history_delete_popup_text: "El servei deixar\xe0 de comptar als llistats i les estad\xedstiques. Aquesta acci\xf3 no esborra el registre, nom\xe9s el marca com a donat de baixa.",
    probio_history_delete_reason_label: "Motiu de la baixa",
    probio_history_deleted_ok: "Servei donat de baixa correctament."
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gZbmW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Resuelve a qué backends habla la app según el hostname.
 *
 * En desarrollo los cuatro proyectos comparten la base `farmaval_probiomentor`:
 * farmavel (que sirve la API en farmavel.test), farmaval-server-v2 y
 * farmaval-v1. Si alguno apunta a otra base, el token se emite contra una y se
 * valida contra otra, y el iframe del servicio responde "Su sesión ha expirado".
 *
 * Antes de la unificación había dos bases y `api_url` tenía que ser
 * https://admin2.farmavel.test/api/; ya no, pero sigue siendo el error de
 * configuración más caro de diagnosticar del entorno: si las cifras que ve un
 * frontend no cuadran, sospecha del host antes que del código.
 */ parcelHelpers.export(exports, "getServerConfig", ()=>getServerConfig);
var _appJson = require("../config/app.json");
var _appJsonDefault = parcelHelpers.interopDefault(_appJson);
function getServerConfig() {
    const hostname = window.location.hostname;
    let environment = 'production';
    // Development environment
    if (hostname === 'localhost' || hostname.endsWith('.test')) environment = 'development';
    else if (hostname.includes('staging')) environment = 'staging';
    const config = (0, _appJsonDefault.default).environments[environment];
    return {
        server_base: config.backend_url,
        api_base: config.api_url || `${config.backend_url.replace(/\/$/, '')}/api/`,
        old_server_base: config.legacy_backend_url,
        assets_base_url: config.assets.base_url
    };
}

},{"../config/app.json":"3MEjQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3MEjQ":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"environments\":{\"development\":{\"env\":\"development\",\"backend_url\":\"http://farmaval-server-v2.test/\",\"api_url\":\"http://farmavel.test/api/\",\"legacy_backend_url\":\"http://farmaval-v1.test/\",\"assets\":{\"base_url\":\"http://farmaval-server-v2.test/\"}},\"staging\":{\"env\":\"staging\",\"backend_url\":\"https://farmaval-server-v2-staging.on-forge.com/\",\"api_url\":\"https://farmavel.on-forge.com/api/\",\"legacy_backend_url\":\"https://farmaval-server-v1-staging.on-forge.com/\",\"assets\":{\"base_url\":\"https://farmaval-server-v2-staging.on-forge.com/\"}},\"production\":{\"backend_url\":\"https://backend-v2.farmaval.net/\",\"api_url\":\"https://farmaval.farmaval.net/api/\",\"legacy_backend_url\":\"https://backend-v1.farmaval.net/\",\"assets\":{\"base_url\":\"https://backend-v2.farmaval.net/\"}}},\"migrated_functions\":{\"login\":{\"url\":\"login\",\"method\":\"POST\"}}}");

},{}],"61pSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repo", ()=>repo);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _appJson = require("../config/app.json");
var _appJsonDefault = parcelHelpers.interopDefault(_appJson);
// Environment configuration
const getServerConfig = ()=>{
    const hostname = location.hostname;
    let environment = 'production';
    if (hostname === 'localhost' || hostname.endsWith('.test')) environment = 'development';
    else if (hostname.includes('staging')) environment = 'staging';
    const config = (0, _appJsonDefault.default).environments[environment];
    return {
        base: config.api_url
    };
};
const config = getServerConfig();
const server_base = config.base;
const server_url = server_base;
// Get session token from localStorage or URL params
const getSessionToken = ()=>{
    const page_vars = new URLSearchParams(window.location.search);
    return localStorage.getItem('farmavel_token') || localStorage.getItem('pharm_token') || page_vars.get('session_token') || '';
};
// Create axios instance
const axiosInstance = (0, _axiosDefault.default).create({
    baseURL: server_base,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    },
    withCredentials: false
});
// Request interceptor to add session token
axiosInstance.interceptors.request.use((config)=>{
    const token = getSessionToken();
    if (token) {
        // Add token as Authorization header (Bearer token)
        config.headers.Authorization = `Bearer ${token}`;
        // Also add as query parameter for backward compatibility
        config.params = config.params || {};
        config.params.session_token = token;
    }
    return config;
}, (error)=>{
    return Promise.reject(error);
});
// Response interceptor for error handling
axiosInstance.interceptors.response.use((response)=>response, (error)=>{
    return Promise.reject(error);
});
const repo = {
    get: (url, params = {})=>{
        return axiosInstance.get(url, {
            params
        });
    },
    post: (url, data = {})=>{
        return axiosInstance.post(url, data);
    },
    put: (url, data = {})=>{
        return axiosInstance.put(url, data);
    },
    delete: (url, params = {})=>{
        return axiosInstance.delete(url, {
            params
        });
    }
};

},{"axios":"kL5AO","../config/app.json":"3MEjQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kL5AO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"dH7oj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dH7oj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"4AdI3","./helpers/bind.js":"dVXC5","./core/Axios.js":"lsoIO","./core/mergeConfig.js":"79q17","./defaults/index.js":"6V8DG","./helpers/formDataToJSON.js":"8eWn8","./cancel/CanceledError.js":"h2iVm","./cancel/CancelToken.js":"2bdtR","./cancel/isCancel.js":"2JSXk","./env/data.js":"2JBGK","./helpers/toFormData.js":"g2re0","./core/AxiosError.js":"fZ7SQ","./helpers/spread.js":"axv13","./helpers/isAxiosError.js":"eb8Z2","./core/AxiosHeaders.js":"jKjps","./adapters/adapters.js":"kiY1x","./helpers/HttpStatusCode.js":"lm3tN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4AdI3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const { iterator, toStringTag } = Symbol;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== 'object') return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(toStringTag in val) && !(iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!isObject(val) || isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest('URLSearchParams');
const [isReadableStream, isRequest, isResponse, isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map(kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if (isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    if (isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless, skipUndefined } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if (isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest('AsyncFunction');
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const _setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        _global.addEventListener("message", ({ source, data })=>{
            if (source === _global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            _global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));
const asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : _setImmediate;
// *********************
const isIterable = (thing)=>thing != null && isFunction(thing[iterator]);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isEmptyObject,
    isReadableStream,
    isRequest,
    isResponse,
    isHeaders,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable,
    setImmediate: _setImmediate,
    asap,
    isIterable
};

},{"./helpers/bind.js":"dVXC5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dVXC5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
'use strict';
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lsoIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, _validatorJsDefault.default).assertOptions(config, {
            baseUrl: validators.spelling('baseURL'),
            withXsrfToken: validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"4AdI3","../helpers/buildURL.js":"4Gx5k","./InterceptorManager.js":"1SpXj","./dispatchRequest.js":"5W7kJ","./mergeConfig.js":"79q17","./buildFullPath.js":"cRRFe","../helpers/validator.js":"ii46t","./AxiosHeaders.js":"jKjps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Gx5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    if ((0, _utilsJsDefault.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

},{"../utils.js":"4AdI3","../helpers/AxiosURLSearchParams.js":"445v1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"445v1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"g2re0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g2re0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if ((0, _utilsJsDefault.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, _utilsJsDefault.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, '[]')) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"cjdyz","../utils.js":"4AdI3","../core/AxiosError.js":"fZ7SQ","../platform/node/classes/FormData.js":"b3JVo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cjdyz":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"bICrG","aceacb6a4531a9d2":"7IMNJ"}],"bICrG":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"7IMNJ":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"fZ7SQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b3JVo":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1SpXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5W7kJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"5PMg8","../cancel/isCancel.js":"2JSXk","../defaults/index.js":"6V8DG","../cancel/CanceledError.js":"h2iVm","../core/AxiosHeaders.js":"jKjps","../adapters/adapters.js":"kiY1x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5PMg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"4AdI3","../defaults/index.js":"6V8DG","../core/AxiosHeaders.js":"jKjps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6V8DG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, _utilsJsDefault.default).isResponse(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"4AdI3","../core/AxiosError.js":"fZ7SQ","./transitional.js":"jktpl","../helpers/toFormData.js":"g2re0","../helpers/toURLEncodedForm.js":"3U162","../platform/index.js":"dnuuz","../helpers/formDataToJSON.js":"8eWn8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jktpl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3U162":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use strict';
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

},{"../utils.js":"4AdI3","./toFormData.js":"g2re0","../platform/index.js":"dnuuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dnuuz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"2AMRr","./common/utils.js":"giiKQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2AMRr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

},{"./classes/URLSearchParams.js":"lpTM0","./classes/FormData.js":"iMRAt","./classes/Blob.js":"hYmoQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lpTM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
exports.default = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"445v1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iMRAt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof FormData !== 'undefined' ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hYmoQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof Blob !== 'undefined' ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"giiKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
parcelHelpers.export(exports, "navigator", ()=>_navigator);
parcelHelpers.export(exports, "origin", ()=>origin);
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const _navigator = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf(_navigator.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const origin = hasBrowserEnv && window.location.href || 'http://localhost';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8eWn8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jKjps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
'use strict';
const $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isObject(header) && (0, _utilsJsDefault.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, _utilsJsDefault.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, _utilsJsDefault.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"4AdI3","../helpers/parseHeaders.js":"hf5eq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hf5eq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

},{"./../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2JSXk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
'use strict';
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h2iVm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? 'canceled' : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"fZ7SQ","../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kiY1x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _fetchJs = require("./fetch.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default),
    fetch: {
        get: _fetchJs.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ const renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function getAdapter(adapters, config) {
    adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!isResolvedHandle(nameOrAdapter)) {
            adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, _utilsJsDefault.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
/**
 * Exports Axios adapters and utility to resolve an adapter
 */ exports.default = {
    /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: knownAdapters
};

},{"../utils.js":"4AdI3","./http.js":"b3JVo","./xhr.js":"f0yTJ","./fetch.js":"1RQlp","../core/AxiosError.js":"fZ7SQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f0yTJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, _resolveConfigJsDefault.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(_config.headers).normalize();
        let { responseType, onUploadProgress, onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)('Request aborted', (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, _axiosErrorJsDefault.default)(msg, (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, _transitionalJsDefault.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, _progressEventReducerJs.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, _progressEventReducerJs.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(_config.url);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)('Unsupported protocol ' + protocol + ':', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"4AdI3","./../core/settle.js":"f469A","../defaults/transitional.js":"jktpl","../core/AxiosError.js":"fZ7SQ","../cancel/CanceledError.js":"h2iVm","../helpers/parseProtocol.js":"5fJNM","../platform/index.js":"dnuuz","../core/AxiosHeaders.js":"jKjps","../helpers/progressEventReducer.js":"ctmjb","../helpers/resolveConfig.js":"ed2el","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f469A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)('Request failed with status code ' + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"fZ7SQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5fJNM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
'use strict';
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctmjb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progressEventReducer", ()=>progressEventReducer);
parcelHelpers.export(exports, "progressEventDecorator", ()=>progressEventDecorator);
parcelHelpers.export(exports, "asyncDecorator", ()=>asyncDecorator);
var _speedometerJs = require("./speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
var _throttleJs = require("./throttle.js");
var _throttleJsDefault = parcelHelpers.interopDefault(_throttleJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const progressEventReducer = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (0, _throttleJsDefault.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const progressEventDecorator = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable,
                total,
                loaded
            }),
        throttled[1]
    ];
};
const asyncDecorator = (fn)=>(...args)=>(0, _utilsJsDefault.default).asap(()=>fn(...args));

},{"./speedometer.js":"eVf9f","./throttle.js":"lGTVn","../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eVf9f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lGTVn":[function(require,module,exports,__globalThis) {
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
exports.default = throttle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ed2el":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _isURLSameOriginJs = require("./isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _cookiesJs = require("./cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _mergeConfigJs = require("../core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _buildURLJs = require("./buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
exports.default = (config)=>{
    const newConfig = (0, _mergeConfigJsDefault.default)({}, config);
    let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
    newConfig.headers = headers = (0, _axiosHeadersJsDefault.default).from(headers);
    newConfig.url = (0, _buildURLJsDefault.default)((0, _buildFullPathJsDefault.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, _utilsJsDefault.default).isFormData(data)) {
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, _utilsJsDefault.default).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, _cookiesJsDefault.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

},{"../platform/index.js":"dnuuz","../utils.js":"4AdI3","./isURLSameOrigin.js":"bJ3hX","./cookies.js":"g1WPK","../core/buildFullPath.js":"cRRFe","../core/mergeConfig.js":"79q17","../core/AxiosHeaders.js":"jKjps","./buildURL.js":"4Gx5k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bJ3hX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, _indexJsDefault.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, _indexJsDefault.default).origin), (0, _indexJsDefault.default).navigator && /(msie|trident)/i.test((0, _indexJsDefault.default).navigator.userAgent)) : ()=>true;

},{"../platform/index.js":"dnuuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g1WPK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, _utilsJsDefault.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, _utilsJsDefault.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, _utilsJsDefault.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, _utilsJsDefault.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"4AdI3","../platform/index.js":"dnuuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cRRFe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
'use strict';
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, _isAbsoluteURLJsDefault.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"WNHRO","../helpers/combineURLs.js":"92Aol","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"WNHRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
'use strict';
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92Aol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
'use strict';
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"79q17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"4AdI3","./AxiosHeaders.js":"jKjps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1RQlp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFetch", ()=>getFetch);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _composeSignalsJs = require("../helpers/composeSignals.js");
var _composeSignalsJsDefault = parcelHelpers.interopDefault(_composeSignalsJs);
var _trackStreamJs = require("../helpers/trackStream.js");
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
const DEFAULT_CHUNK_SIZE = 65536;
const { isFunction } = (0, _utilsJsDefault.default);
const globalFetchAPI = (({ Request, Response })=>({
        Request,
        Response
    }))((0, _utilsJsDefault.default).global);
const { ReadableStream, TextEncoder } = (0, _utilsJsDefault.default).global;
const test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const factory = (env)=>{
    env = (0, _utilsJsDefault.default).merge.call({
        skipUndefined: true
    }, globalFetchAPI, env);
    const { fetch: envFetch, Request, Response } = env;
    const isFetchSupported = envFetch ? isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = isFunction(Request);
    const isResponseSupported = isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, _indexJsDefault.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(()=>(0, _utilsJsDefault.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, _axiosErrorJsDefault.default)(`Response type '${type}' is not supported`, (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, _utilsJsDefault.default).isBlob(body)) return body.size;
        if ((0, _utilsJsDefault.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, _indexJsDefault.default).origin, {
                method: 'POST',
                body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, _utilsJsDefault.default).isArrayBufferView(body) || (0, _utilsJsDefault.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, _utilsJsDefault.default).isURLSearchParams(body)) body = body + '';
        if ((0, _utilsJsDefault.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, _utilsJsDefault.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, withCredentials = 'same-origin', fetchOptions } = (0, _resolveConfigJsDefault.default)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, _composeSignalsJsDefault.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, _utilsJsDefault.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, _progressEventReducerJs.progressEventDecorator)(requestContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onUploadProgress)));
                    data = (0, _trackStreamJs.trackStream)(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, _utilsJsDefault.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, _utilsJsDefault.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, _progressEventReducerJs.progressEventDecorator)(responseContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onDownloadProgress), true)) || [];
                response = new Response((0, _trackStreamJs.trackStream)(response.body, DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, _utilsJsDefault.default).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, _settleJsDefault.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, _axiosHeadersJsDefault.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config,
                    request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, _axiosErrorJsDefault.default).from(err, err && err.code, config, request);
        }
    };
};
const seedCache = new Map();
const getFetch = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request, Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : factory(env));
        map = target;
    }
    return target;
};
const adapter = getFetch();
exports.default = adapter;

},{"../platform/index.js":"dnuuz","../utils.js":"4AdI3","../core/AxiosError.js":"fZ7SQ","../helpers/composeSignals.js":"5luDQ","../helpers/trackStream.js":"5CnPE","../core/AxiosHeaders.js":"jKjps","../helpers/progressEventReducer.js":"ctmjb","../helpers/resolveConfig.js":"ed2el","../core/settle.js":"f469A","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5luDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const composeSignals = (signals, timeout)=>{
    const { length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, _axiosErrorJsDefault.default) ? err : new (0, _canceledErrorJsDefault.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, _axiosErrorJsDefault.default)(`timeout ${timeout} of ms exceeded`, (0, _axiosErrorJsDefault.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal } = controller;
        signal.unsubscribe = ()=>(0, _utilsJsDefault.default).asap(unsubscribe);
        return signal;
    }
};
exports.default = composeSignals;

},{"../cancel/CanceledError.js":"h2iVm","../core/AxiosError.js":"fZ7SQ","../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5CnPE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamChunk", ()=>streamChunk);
parcelHelpers.export(exports, "readBytes", ()=>readBytes);
parcelHelpers.export(exports, "trackStream", ()=>trackStream);
const streamChunk = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const readBytes = async function*(iterable, chunkSize) {
    for await (const chunk of readStream(iterable))yield* streamChunk(chunk, chunkSize);
};
const readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done, value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const trackStream = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = readBytes(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done, value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ii46t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
const validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, _dataJs.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, _axiosErrorJsDefault.default)('options must be an object', (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)('option ' + opt + ' must be ' + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)('Unknown option ' + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"2JBGK","../core/AxiosError.js":"fZ7SQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2JBGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.13.2";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2bdtR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"h2iVm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"axv13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
'use strict';
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eb8Z2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lm3tN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f3kwi":[function(require,module,exports,__globalThis) {
/**
 * Registry único de servicios del frontend.
 *
 * FUENTE DE VERDAD para metadatos de presentación: DOM id, claves i18n, schedulable.
 * Sustituye las 3 definiciones duplicadas que existían en:
 *   - src/js/index.js (arrays is_schedulable, special-case PROBIOMENTOR→service_PROBIO)
 *   - src/js/farmaval.js (serviceTranslations)
 *   - section_services.html (ids de tarjetas)
 *
 * El GRUPO MÉDICO de cada servicio (respiratorio, probioticos…) viene del backend
 * (endpoint GET /v1/services). No se duplica aquí.
 *
 * Para añadir un servicio nuevo:
 *   1. Insertar en la tabla `services` del backend (seeder/SQL) con su grupo.
 *   2. Añadir la entrada aquí con su domId, claves i18n y schedulable.
 *   3. Crear la tarjeta HTML en section_services.html.
 *   4. Si el servicio pertenece a un grupo existente, NO se toca serviceMenus.js.
 *      Si crea un grupo nuevo, declarar su perfil en serviceMenus.js.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SERVICES", ()=>SERVICES);
parcelHelpers.export(exports, "SERVICE_ALIASES", ()=>SERVICE_ALIASES);
/**
 * Normaliza un código de servicio resolviendo aliases.
 * @param {string} code
 * @returns {string}
 */ parcelHelpers.export(exports, "normalizeServiceCode", ()=>normalizeServiceCode);
/**
 * Devuelve el mapa serviceTranslations compatible con translateServices()
 * de farmaval.js (domId → [langName, langDesc]).
 * Así farmaval.js ya no necesita mantener ese objeto a mano.
 */ parcelHelpers.export(exports, "buildServiceTranslationsMap", ()=>buildServiceTranslationsMap);
const SERVICES = {
    CEPOC: {
        domId: 'service_CEPOC',
        langName: 'cepoc_name',
        langDesc: 'cepoc_desc',
        schedulable: true
    },
    SATI: {
        domId: 'service_SATI',
        langName: 'sati_name',
        langDesc: 'sati_desc',
        schedulable: true
    },
    SATI_TEST: {
        domId: 'service_SATI_TEST',
        langName: 'sati_test_name',
        langDesc: 'sati_test_desc',
        schedulable: true
    },
    IRETIA: {
        domId: 'service_IRETIA',
        langName: 'iretia_name',
        langDesc: 'iretia_desc',
        schedulable: false
    },
    PROBIOMENTOR: {
        domId: 'service_PROBIO',
        langName: 'probio_name',
        langDesc: 'probio_desc',
        schedulable: false
    }
};
const SERVICE_ALIASES = {
    PROBIO: 'PROBIOMENTOR'
};
function normalizeServiceCode(code) {
    return SERVICE_ALIASES[code] || code;
}
function buildServiceTranslationsMap() {
    return Object.fromEntries(Object.values(SERVICES).map((s)=>[
            s.domId,
            [
                s.langName,
                s.langDesc
            ]
        ]));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}]},["csIXA"], "csIXA", "parcelRequiree3ea", {})

//# sourceMappingURL=registro.39e7a1f3.js.map
